import React, { useContext, useEffect, useState, useRef , useMemo } from 'react'
import { Row, Col } from 'react-bootstrap';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { Autocomplete, Button, Chip, CircularProgress, Badge , colors, Table, TableBody, Tooltip , TableCell, TableContainer, TableHead, TableRow, TextField, Typography, IconButton, MenuItem, Divider, Menu, Switch, Tabs, Tab } from '@mui/material';
import CollapseComponent from '../../components/Schedule/CollapseComponent';
import ApiService from '../../functions/apiService';
import { useSnackbar } from 'notistack';
import moment from 'moment/moment';
import { useSelector, useDispatch } from 'react-redux'
import { setDashboard, setDashboardSelectedEmp, setDashboardShifts, setDashboardAbsentReasonAll, setDashboardEmployeeToSwap } from '../../store/dashboardReducer'
import ArrowLeft from "../../components/Calendar/ArrowLeft";
import ArrowRight from "../../components/Calendar/ArrowRight";
import AuthContext from '../../context/AuthContext';
import { useNavigate, useSearchParams } from 'react-router-dom';
import AddOverTime from '../../components/Schedule/AddOverTime'
import ManagementHeaderNav from '../../components/HeadersNav/ManagementHeaderNav';
import DashboardMemberLog from '../../components/Schedule/DashboardMemberLog';
import { getGridStringOperators } from '@mui/x-data-grid';
import AddNote from '../../components/Schedule/AddNote';
import ManagementDetail from '../../components/Schedule/ManagementDetail';
import OffDutyTraining from '../../components/Schedule/OffDutyTraining';
import DutyCrew from '../../components/Schedule/DutyCrew';
import ButtonDatePicker from '../../components/DatePickers/ButtonDatePicker';
import { setPossitionListDDL } from '../../store/ddlReducer';
import { Available, OutOfTown } from '../../components/Schedule/OutOfTown';
import { styled } from '@mui/material/styles';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Modal from 'react-bootstrap/Modal';
import ToggleComponent from './toggleComponent';
import HorizontalComponent from './horizontalComponent';
import FullViewComponent from './FullViewComponent';
import CustomSelect from '../../components/Schedule/CustomSelect';
import { QuickAssign, AssignModal } from '../../components/Schedule/QuickAssign';
import SliderComponent from '../../components/Schedule/SliderComponent';
import EmptyState from '../../components/Error/EmptyState';
import { ToggleButton, ToggleButtonGroup } from '@mui/material';
import SweetAlert from 'react-bootstrap-sweetalert';
import { toast } from "react-toastify";
import { RevertStation } from './RevertStation';
import { varFormatTime } from '../../utils/helperFunctions';
import VolunteerSignup from './VolunteerSignup';
import AssignmentRequests from '../AssignmentRequests/AssignmentRequests.jsx';
import CancelledAssignments from '../PositionAssignment/CancelledAssignments.jsx';
import VolunteerSignupNew from '../OvertimeSignup/VolunteerSignupNew.jsx';
import { drop } from 'lodash';
import { RotationTable } from './RotationTable';
import dayjs from "dayjs";
import { CalendarToday } from "@mui/icons-material";
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { CgOptions } from "react-icons/cg";
import ZoomOutMapIcon from '@mui/icons-material/ZoomOutMap';
import { KeyboardArrowLeft, KeyboardArrowRight } from "@mui/icons-material";
import { MobileDatePicker } from '@mui/x-date-pickers';
import ButtonDatePickerNew from '../../components/DatePickers/ButtonDatePickerNew';
// import { getShiftSlots } from '../../utils/formatDate'
import { Link } from 'react-router-dom';
import { useReactToPrint } from "react-to-print";
import ButtonTheme from '../../components/ThemeButton/ThemeButton';

const buttonStyle = {
    fontSize: '12px',
    fontWeight: '700',
    color: "#BF1D2D",
    height: '38px',
    padding: '10px 10px',
    border: '1px solid #BF1D2D',
    lineHeight: '15px',
    "&:hover": {
        color: '#fff',
        backgroundColor: '#BF1D2D'
    },
    "&:disabled": {
        color: '#fff',
        backgroundColor: '#D0D5DD',
        border: '1px solid #D0D5DD',
    }
};

const StyledToggleButton = styled(ToggleButton)(({ theme }) => ({
    width: 40,
    height: 48,
    textTransform: 'none',
    border: '1px solid #ccc',
    backgroundColor: '#ffffff',
    borderRadius: '60px',
    '&.Mui-selected': {
        backgroundColor: theme.palette.mode === 'dark' ? '1px solid rgba(224, 224, 224, 1)' : '1px solid rgba(224, 224, 224, 1)',
        color: '#fff',
        '&:hover': {
            backgroundColor: theme.palette.mode === 'dark' ? '1px solid rgba(224, 224, 224, 1)' : '1px solid rgba(224, 224, 224, 1)',
        },
    },
}));

export const getShiftSlots = (customShiftsArray, shiftStartTime, shiftEndTime) => {
    const parseTime = (time) => {
        const [h, m, s = 0] = time?.split(':')?.map(Number);
        return h * 60 + m + s / 60;
    };
    const formatMinutes = (mins) => {
        let h = Math.floor(mins / 60) % 24;
        let m = Math.floor(mins % 60);
        return `${h.toString().padStart(2, '0')}:${m.toString().padStart(2, '0')}`;
    };

    const parseCustomTime = (timeStr) => {
        const match = timeStr?.match(/\((\d{2}:\d{2})\s*-\s*(\d{2}:\d{2})\)/);
        if (match) {
            return {
                Start_Time: match[1] + ':00',
                End_Time: match[2] + ':00'
            };
        }
        return null;
    };

    let startMin = parseTime(shiftStartTime);
    let endMin = parseTime(shiftEndTime);

    const isOvernight = endMin <= startMin;
    if (isOvernight) endMin += 24 * 60;

    const normalizeTime = (t) => {
        let val = parseTime(t);
        if (isOvernight && val < startMin) val += 24 * 60;
        return val;
    };

    // Parse and sort the occupied time slots
    const occupiedSlots = customShiftsArray
        ?.map(shift => {
            const times = parseCustomTime(shift.custom_time);
            if (!times) return null;

            return {
                ...shift,
                Start_Time: times.Start_Time,
                End_Time: times.End_Time
            };
        })
        .filter(Boolean)
        .sort((a, b) => normalizeTime(a.Start_Time) - normalizeTime(b.Start_Time));

    const slots = [];
    let currentStart = startMin;

    occupiedSlots?.forEach((emp) => {
        let empStart = normalizeTime(emp.Start_Time);
        let empEnd = normalizeTime(emp.End_Time);

        if (empEnd <= empStart) empEnd += 24 * 60;

        // Add available slot before this occupied slot
        if (empStart > currentStart) {
            slots.push({
                type: 'open',
                start: currentStart,
                end: empStart
            });
        }

        // Add the occupied slot
        slots.push({
            type: 'filled',
            ...emp,
            start: empStart,
            end: empEnd,
        });

        currentStart = empEnd;
    });

    // ✅ NIGHT SHIFT FIX: Stop availability at first filled slot AFTER shift start
    if (isOvernight) {
        const firstFilledAfterStart = slots.find(
            s => s.type === 'filled' && s.start > startMin
        );

        if (firstFilledAfterStart) {
            // Only add availability up to the first filled slot
            return {
                slots: slots.map(s => {
                    // If this is the initial open slot, cut it at first filled
                    if (s.type === 'open' && s.start === startMin) {
                        return {
                            ...s,
                            end: firstFilledAfterStart.start,
                        };
                    }
                    return s;
                }),
                formatMinutes,
            };
        }
    }

    // ✅ Add remaining available time ONLY if no occupied slot after currentStart
    if (currentStart < endMin) {
        slots.push({
            type: 'open',
            start: currentStart,
            end: endMin,
        });
    }

    return { slots, formatMinutes };
};

export default function Management() {
    const { permission, pages, pagesName, is_dn_deparment, user, v3Data } = useContext(AuthContext);
    let data = useSelector((state) => state.dashboardReducer.Data)
    let date = useSelector((state) => state.dashboardReducer.Date)
    let SelectedEmp = useSelector((state) => state.dashboardReducer.SelectedEmp)
    let Shifts = useSelector((state) => state.dashboardReducer.Shifts)
    let PossitionListDDL = useSelector((state) => state.ddlReducer.PossitionListDDL)
    const dispatch = useDispatch()
    let navigate = useNavigate();
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const isDisabled = false;
    const isLoading = false;
    const isRtl = false;
    const isSearchable = true;

    const [searchParams, setSearchParams] = useSearchParams();
    const routeDate = searchParams.get('date');
    const [loading, setLoading] = useState(true);
    const [showDay, setShowDay] = useState(false);
    const [positionLoading, setPositionLoading] = useState(false);
    const [mode, setMode] = useState('');
    const [isNightShift, setIsNightShift] = useState(false);
    const [expandAll, setExpandAll] = useState(true);
    const [anyExpanded, setAnyExpanded] = useState(true);
    const [isScrolled, setIsScrolled] = useState(false);
    const [newData, setNewData] = useState([])
    const [requiredPositionCounts, setRequiredPositionCounts] = useState('')
    const [requiredVehicleCounts, setRequiredVehicleCounts] = useState('')

    const [dayData, setDayData] = useState([])
    const [currentVehicleCounts, setCurrentVehicleCounts] = useState({})
    const [currentPositionCounts, setCurrentPositionCounts] = useState({})
    const [emptyOfficers, setEmptyOfficers] = useState([])
    const [emptyCounts, setEmptyCounts] = useState([])

    const [nightData, setNightData] = useState([])
    const [currentVehicleCountsNight, setCurrentVehicleCountsNight] = useState({})
    const [currentPositionCountsNight, setCurrentPositionCountsNight] = useState({})
    const [emptyOfficersNight, setEmptyOfficersNight] = useState([])
    const [emptyCountsNight, setEmptyCountsNight] = useState([])

    const [overTimeModal, setOverTimeModal] = useState(false)
    const [showToggleComponent, setShowToggleComponent] = useState(false);
    const [assignModal, setAssignModal] = useState(false)
    const [battalion, setBattalion] = useState(null);
    const [selectedSOValue, setselectedSOValue] = useState('');
    const [selectEmployee, setSelectEmployee] = useState([])
    const [shift, setShift] = useState('day');
    const [showAlert, setShowAlert] = useState(false)
    const [eligibleAlert, setEligibleAlert] = useState(false)
    const [positionData, setPositionData] = useState({})
    const [prevdates, setPrevDates] = useState([]);
    const [nextDates, setNextDates] = useState([]);
    const [assigndataModal, setAssignDataModal] = useState(false)
    const [revertStation, setRevertStation] = useState(false)
    const [revertData, setRevertData] = useState([])
    const [assignmentsModal, setAssignmentsModal] = useState(false)
    const [assignmentsTab, setAssignmentsTab] = useState('')
    const [canPositionCount, setCanPositionCount] = useState(false)
    const [canRemoveOpenPos, setCanRemoveOpenPos] = useState(false)
    const [showAllOpenPos, setShowAllOpenPos] = useState(false)
    const allowedVars = v3Data;

    const canViewAssignmentRequests = !!(permission && permission.includes('Emp_Auth') && pages && pages.includes('V3_Volunteer_Signup'));
    const canViewCancelledAssignments = !!(permission && permission.includes('Emp_Auth') && pages && pages.includes('V3_Volunteer_Signup'));
    const canViewVolunteerSignup = !!(permission && permission.includes('Emp_Auth') && pages && pages.includes('V3_Volunteer_Signup'));
    const volunteerSignupLabel = v3Data?.V3_VERBIAGE_VOLUNTEER ? 'Per-diem Signup' : 'Volunteer Signup';
    const showAssignmentsButton = canViewAssignmentRequests || canViewCancelledAssignments || canViewVolunteerSignup;

    const openAssignmentsModal = () => {
        const defaultTab = canViewAssignmentRequests ? 'requests' : (canViewCancelledAssignments ? 'cancelled' : 'volunteerSignup');
        setAssignmentsTab(defaultTab);
        setAssignmentsModal(true);
    };

    const [employees, setEmployees] = useState([])
    const [empSearch, setEmpSearch] = useState('')
    const [empLoading, setEmpLoading] = useState(false);
    const [selectedSearchEmp, setSelectedSearchEmp] = useState('');
    const [showDropdowns, setShowDropdowns] = useState(true);
    const [enableMultiSelect, setEnableMultiSelect] = useState(false);

    const [isOnlyNightEmployee, setIsOnlyNightEmployee] = useState(false);

    const [dropdownStyle, setDropdownStyle] = useState({
        opacity: 0,
        transform: 'translateY(-10px)',
        transition: 'opacity 0.3s ease, transform 0.3s ease',
        pointerEvents: 'none',
    });
    const [dropdownStyle2, setDropdownStyle2] = useState({
        opacity: 0,
        transform: 'translateY(-10px)',
        transition: 'opacity 0.3s ease, transform 0.3s ease',
        pointerEvents: 'none',
    });
    const [isReload, setIsReload] = useState(false)
    const [allShifts, setAllShifts] = useState('')
    // const [calendarData, setCalendarData] = useState({});
    const today = dayjs();
    const [anchorEl, setAnchorEl] = useState(null);
    const [showDots, setShowDots] = useState([]);
    const isIPad = useMediaQuery('(min-width: 660px) and (max-width: 1100px)');
    const [selectedDate, setSelectedDate] = useState(() => {
        const savedDate = localStorage.getItem('scheduleDate');
        if (savedDate) {
            return dayjs(savedDate);
        }
        return routeDate ? dayjs(routeDate) : dayjs();
    });
    const printRef = useRef(null);
    const detailRef = useRef(null);
    const clonedDetailRef = useRef(null);

    const weekDays = useMemo(() => {
        const weekStart = dayjs(selectedDate).startOf("week");

        return Array.from({ length: 7 }, (_, i) => {
            const date = weekStart.add(i, "day");
            const dateStr = date.format('YYYY-MM-DD');
            // const hasOvertime = calendarData?.overtime?.some(
            //     overtime => overtime.shiftDate === dateStr && overtime.count > 0
            // );
            const dotData = showDots?.find(
                (item) => item.date === dateStr
            );

            return {
                day: date.format("ddd").toUpperCase(),
                date: date.date().toString(),
                active: date.isSame(today, "day"),
                highlighted: date.isSame(selectedDate, "day"),
                fullDate: date,
                // hasOvertime: hasOvertime || false, 
                showRedDot: (dotData?.openPositionCount ?? 0) > 0,
                showYellowDot: (dotData?.requestedCount ?? 0) > 0,
                group: dotData?.group || "",
                color: dotData?.color || "",
            };
        });
    }, [selectedDate, showDots]);


    const startDate = useMemo(() => {
        return weekDays.length > 0 ? weekDays[0].fullDate : dayjs();
    }, [weekDays]);


    const endDate = useMemo(() => {
        return weekDays.length > 0 ? weekDays[6].fullDate : dayjs();
    }, [weekDays]);


    const formattedRange = useMemo(() => {
        if (weekDays.length > 0) {
            return weekDays[0].fullDate.format("MMM D") + " - " + weekDays[6].fullDate.format("MMM D, YYYY");
        }
        return "";
    }, [weekDays]);

    const ChangeDateArrow = (direction) => {
        const newDate = selectedDate.add(direction * 7, "day");
        const formattedDate = newDate.format('YYYY-MM-DD');
        setSelectedDate(newDate);
        localStorage.setItem('scheduleDate', formattedDate);
        loadData(newDate.format('DD-MM-YYYY'));
        setSearchParams({ date: newDate.format('YYYY-MM-DD') });
        setIsNightShift(false);
        // getWeekCalendar(newDate);
        getWeeklySchedule(newData)
    };

    const open = Boolean(anchorEl);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };


    const [filterAnchorEl, setFilterAnchorEl] = useState(null);
    const filterMenuOpen = Boolean(filterAnchorEl);
    const [isDaysVisible, setIsDaysVisible] = useState(false);
    const [isPositionsVisible, setIsPositionsVisible] = useState(false);

    const handleFilterClick = (event) => setFilterAnchorEl(event.currentTarget);
    const handleFilterClose = () => setFilterAnchorEl(null);

    const [anchorElOptions, setAnchorElOptions] = React.useState(null);
    const handleOpenOptions = (event) => setAnchorElOptions(event.currentTarget);
    const handleCloseOptions = () => setAnchorElOptions(null);
    const [currentDate, setCurrentDate] = useState(dayjs());



    useEffect(() => {
        if (selectedDate) {
            const formattedDate = selectedDate.format('YYYY-MM-DD');
            localStorage.setItem('scheduleDate', formattedDate);
        }
        if (selectedDate) {
            // getWeekCalendar(selectedDate);
            getWeeklySchedule(selectedDate)
        }
    }, [selectedDate]);

    useEffect(() => {
        if (Object.keys(allowedVars).includes('V3_AUTO_SHOW_DAY_STAFF')) {
            setShowDay(true)
            setIsDaysVisible(true)
        }
    }, [allowedVars.V3_AUTO_SHOW_DAY_STAFF])

    const handlePrevDay = () => {
        setCurrentDate(prev => prev.subtract(1, "day"));
    };

    const handleNextDay = () => {
        setCurrentDate(prev => prev.add(1, "day"));
    };

    // const getWeekCalendar = async (date) => {
    //     try {
    //         const response = await ApiService.get(
    //             `/calendar/${date.year()}/${date.month() + 1}`, 
    //             {}, 
    //             'calendar'
    //         );
    //         setCalendarData(response.data);
    //     } catch (error) {
    //         console.error('Error fetching calendar:', error);
    //     }
    // };
    const refreshWeeklyData = () => {
        if (selectedDate) {
            getWeeklySchedule(selectedDate);
        }
    };
    const getWeeklySchedule = async (startDate) => {
        try {
            const response = await ApiService.post(
                '/weeklySchedule',
                {
                    date: startDate.format('YYYY-MM-DD')
                },
                {},
                'weeklySchedule'
            )
            if (response?.success) {
                setShowDots(response?.data)
            }
        } catch (error) {
            console.error('Error fetching weekly schedule:', error);
        }
    };

    const activeFilterCount = [isDaysVisible, isPositionsVisible, enableMultiSelect].filter(Boolean).length;

    const [mode2, setMode2] = useState(() => {
        const storedMode = localStorage.getItem("mode");
        if (storedMode && storedMode !== '') {
            return storedMode;
        }
        else if (pages.includes("V3_DEFAULT_TOGGLE_VIEW")) {
            return "24";
        }
        else {
            return "day";
        }
    });

    useEffect(() => {
        if (is_dn_deparment === 'DN_TOGGLE') {
            localStorage.setItem("mode", mode2);
        }
    }, [mode2]);

    const handleModeChange = (event, newMode) => {
        if (newMode !== null) {
            setMode2(newMode);
        }
    };

    const handleScroll = () => {
        const scrollTop = window.scrollY;
        setIsScrolled(scrollTop > 300);
    };

    useEffect(() => {
        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    const toggleAllCollapses = () => {
        setExpandAll(prev => !prev);
        if (!expandAll) {
            setAnyExpanded(true);
        }
        else {
            setAnyExpanded(false);
        }
    };

    const handleExpandChange = (isExpanded) => {
        if (isExpanded) {
            setAnyExpanded(true);
        }
        else {
            setAnyExpanded(false);
        }
    };

    const handleShiftToggle = () => {
        setIsNightShift(!isNightShift);
    };

    const handleSelectChange = (e, row, day) => {
        const posObj = {
            e: e,
            emp: row,
            day: day
        }
        setPositionData(posObj)
        changeEmpPossion(posObj)
    };

    let changeEmpPossion = (posData) => {
        if (!posData?.emp) {
            toast.error('No assignment for this position')
        }
        else {
            if (posData?.emp?.Position_Code == posData?.e?.value) {
                toast.error('Same position')
            }
            else if (!posData?.e?.dataAssignment) {
                toast.error('No assignment for this position')
            }
            else if (!allowedVars || !Object.keys(allowedVars).includes('V3_REASSIGNMENT_CHECK_CERTIFICATES')) {
                empPositionEligible(posData)
            }
            else {
                ApiService.post('/check-emp-reassign-eligible', {
                    "Emp_Code": posData?.emp?.Emp_Code,
                    "Position_Code": posData?.e?.value,
                }).then((res) => {
                    if (res?.isEligible) {
                        empPositionEligible(posData)
                    }
                    else {
                        setEligibleAlert(true)
                    }
                }).catch(({ error }) => {
                    console.log('error', error)
                });
            }
        }
    }

    const empPositionEligible = (posDataa) => {
        const posData = posDataa ? posDataa : positionData;
        setEligibleAlert(false)
        setPositionLoading(true)
        ApiService.post('/changeEmployeeSchedule', {
            "EmpCode": posData.emp.Emp_Code,
            "Possition": posData.e.value,
            "Assignment": posData.e.dataAssignment.Assignment,
            "Vehicle": posData.e.dataAssignment.Vehicle || null,
            "ShiftDate": data.date,
            "ShiftCode": (posData.day != null && posData.day == false) || isNightShift ? 3 : 2
        }).then(() => {
            setPositionData({})
            setPositionLoading(false)
            loadData(moment(data.date, 'YYYY-MM-DD').format('DD-MM-YYYY'))
        }).catch(({ error }) => {
            setPositionLoading(false)
            console.log('error', error)
        });
    }

    let getReqCounts = () => {
        ApiService.get('/get-shift-requirement-counts')
            .then((res) => {
                setRequiredPositionCounts(res?.data?.data)
            }).catch(({ error }) => {
                console.log('error', error)
            });
    }

    let getReqVehicleCounts = () => {
        ApiService.get('/getVehicles')
            .then((res) => {
                let tempObj = {}
                res?.data?.data?.map((vehi) => {
                    tempObj[vehi?.SO_Value] = {
                        "position": vehi?.SO_Desc,
                        "min": vehi?.SO_Condition?.split(',')[0].split('-')[1],
                        "max": vehi?.SO_Condition?.split(',')[1].split('-')[1]
                    }
                })
                setRequiredVehicleCounts(tempObj)
            }).catch((error) => {
                console.log('error')
            });
    }

    const getMinWidth = () => {
        if (is_dn_deparment === 'DN_24_VIEW') return 100;
        if (is_dn_deparment === '24_FULL_VIEW') return 20;
        if (is_dn_deparment === 'DN_TOGGLE' && !mode2 == '24') return 240;
        if (is_dn_deparment === 'DN_TOGGLE' && mode2 == '24') return 220;
    };

    const getMaxWidth = () => {
        if (is_dn_deparment === 'DN_24_VIEW') return 140;
        if (is_dn_deparment === '24_FULL_VIEW') return 170;
        if (is_dn_deparment === 'DN_TOGGLE') return 300;
    };

    const minWidth = getMinWidth();
    const maxWidth = getMaxWidth();

    const getEmpNameStyle = (params, day = null) => {
        let color = params.row.EA_Status === 'N' ? 'orange' : 'inherit'
        let EmployeeName = `${params.row.EA_Rank} ${params.row.fullName}`
        let textEmployee = `${params.row.EA_Rank} ${params.row.fullName}`
        let reason = ''



        if (mode2 === 'night') {
            if (params?.row?.customShiftsArrayNight?.length > 0) {

                const selectedShift = Shifts?.find((shift) =>
                    day
                        ? shift.Shift === "Day"
                        : shift.Shift === "Night"
                );
                const startTime = selectedShift?.Start_Time;
                const endTime = selectedShift?.End_Time;

                const { slots: slotsData, formatMinutes } = getShiftSlots(
                    params?.row?.customShiftsArrayNight,
                    startTime,
                    endTime
                );
                const availableTimesFromSlots = slotsData
                    ?.filter(slot => slot.type === 'open')
                    ?.map(slot => `${formatMinutes(slot.start)}-${formatMinutes(slot.end)}`)
                    ?.join(', ');

                return (
                    <>
                        <div className={`${(params?.row?.customShiftsArrayDay?.length > 0 || params?.row?.customShiftsArrayNight?.length > 0) && 'shift-arr'}`}>
                            {textEmployee}
                            {allowedVars?.V3_ADD_BRACKET_WITH_HOURS_EMP === "true" &&
                                availableTimesFromSlots && (
                                    <span style={{ marginLeft: 6, fontWeight: 'bold', color: '#079E46' }}>
                                        ({availableTimesFromSlots})
                                    </span>
                                )
                            }
                        </div>
                        {params?.row?.customShiftsArrayNight?.map((shift) => {
                            reason = shift.absentReason
                            textEmployee = `, Open Position (${varFormatTime(shift.custom_time, user?.Time_Format)})`
                            if (shift.dayStatus == 'F') {
                                reason = ''
                                textEmployee = ` ${shift.DayFillEmpEA_Rank} ${shift.DayFillEmpFirst_name} ${shift.DayFillEmpLast_name} (${varFormatTime(shift.custom_time, user?.Time_Format)})`
                            }
                            let color = 'inherit'
                            if (shift.absentColor == 'red') {
                                color = shift.absentColor || '#E62719'
                            } else if (shift.absentColor == 'orange') {
                                color = shift.absentColor || 'orange'
                            } else if (shift.absentColor == 'green') {
                                color = shift.absentColor || '#079E46'
                            } else if (shift.absentColor == 'blue') {
                                color = shift.absentColor || '#8cbaf9'
                            }
                            return (
                                <div className={`${(params?.row?.customShiftsArrayDay?.length > 0 || params?.row?.customShiftsArrayNight?.length > 0) && 'shift-arr'}`}
                                    style={{
                                        color: color,
                                        fontWeight: params.row.EA_Status === 'N' ? 'bold' : 'normal',
                                        whiteSpace: 'normal',
                                        wordBreak: 'break-word',
                                        textOverflow: 'ellipsis',
                                    }}>
                                    <span style={{ fontWeight: 'bold' }}>{reason}</span>
                                    {textEmployee}
                                    <span style={{
                                        backgroundColor: color, borderRadius: 50, color: '#fff',
                                        fontWeight: 'bold', fontSize: 11, marginLeft: 5, width: 20,
                                        height: 20, display: 'inline-flex', alignItems: 'center', justifyContent: 'center'
                                    }}>
                                        P{shift.dayStatus}
                                    </span>
                                    {pages.includes('V3_SCHEDULE_QUICK_ASSIGNMENTS') && permission && permission.includes('Emp_Auth') && (
                                        shift.dayStatus == 'O' ? (
                                            <img src="/images/overtime.png"
                                                onClick={(event) => {
                                                    event.stopPropagation();
                                                    setAssignModal(true);
                                                    setSelectEmployee([params.row.Emp_Code])
                                                }}
                                                width={30}
                                                height={30}
                                                style={{ cursor: 'pointer' }}
                                            />
                                        ) : (
                                            <></>
                                        )
                                    )}
                                    {permission && permission.includes('Emp_Auth')
                                        && (pages.includes('V3_STATION_DETAIL_REVERT'))
                                        && (shift.absentReason === 'STATION DETAIL' || shift.absentReason === 'Station Detail') &&
                                        <img
                                            src="/images/revert.png"
                                            onClick={() => {
                                                setRevertStation(true)
                                                setRevertData(params?.row)
                                            }}
                                            width={22}
                                            height={22}
                                            style={{ cursor: 'pointer', marginLeft: '5px' }}
                                        />
                                    }
                                </div>
                            )
                        })}
                    </>
                )
            }
            else {
                if (params.row.nightStatus === "F" && params.row.NightFillEmpFirst_name) {
                    textEmployee = `${params.row.NightFillEmpEA_Rank} ${params.row.NightFillEmpFirst_name} ${params.row.NightFIllEmpLast_name}`;
                    color = params.row.absentColorNight || '#079E46';
                }
                if (params.row.nightStatus === "O") {
                    reason = params.row.absentReasonNight;
                    textEmployee = `, Open Position`;
                    color = params.row.absentColorNight || '#E62719';
                }
                if (params.row.nightStatus === "D") {
                    reason = params.row.absentReasonNight;
                    textEmployee = `, Open Position`;
                    color = params.row.absentColorNight || '#000000';
                }
                if (params.row.nightStatus === "Q") {
                    reason = params.row.absentReasonNight;
                    textEmployee = `, Open Position`;
                    color = params.row.absentColorNight || '#FFA500';
                }

                return (
                    <div className={`${(params?.row?.customShiftsArrayDay?.length > 0 || params?.row?.customShiftsArrayNight?.length > 0) && 'shift-arr'}`}
                        style={{
                            color: color,
                            fontWeight: params.row.EA_Status === 'N' ? 'bold' : 'normal',
                            whiteSpace: 'normal',
                            wordBreak: 'break-word',
                            textOverflow: 'ellipsis',
                        }}>
                        {!params.row.nightStatus == " " && allowedVars.V3_SHOW_ORIGINAL_MEMBER_SCHEDULE == "true" &&
                            <span style={{
                                marginRight: '10px',
                                color: params.row.nightStatus == 'F' ? '#000000' : params.row.absentColorNight
                            }}>{EmployeeName}</span>
                        }
                        {!params.row.nightStatus == " " && allowedVars.V3_SHOW_ORIGINAL_MEMBER_SCHEDULE == "true" &&
                            <img src='/images/right-arrow-new.svg' height={'16px'} width={'16px'} style={{ marginRight: '10px' }} />
                        }
                        <span style={{ fontWeight: 'bold' }}>{reason}</span>
                        {textEmployee}
                        {pages.includes('V3_SCHEDULE_QUICK_ASSIGNMENTS') && permission && permission.includes('Emp_Auth') && (
                            params.row.absentReasonNight && params.row.nightStatus === 'O' ? (
                                <img
                                    src="/images/overtime.png"
                                    onClick={(event) => {
                                        event.stopPropagation();
                                        setAssignModal(true);
                                        setSelectEmployee([params.row.Emp_Code])
                                    }}
                                    width={30}
                                    height={30}
                                    style={{ cursor: 'pointer' }}
                                />
                            ) : null
                        )}
                        {permission && permission.includes('Emp_Auth') && (params.row.absentReasonNight && params.row.nightStatus === 'O') && (pages.includes('V3_EMPLOYEE_DROP_DOWN')) ? (
                            <img
                                src="/images/assign-image.png"
                                onClick={(event) => {
                                    event.stopPropagation();
                                    setAssignDataModal(true);
                                    setSelectEmployee([params.row.Emp_Code])
                                }}
                                width={22}
                                height={22}
                                style={{ cursor: 'pointer', marginLeft: '10px' }}
                            />
                        ) : null
                        }

                        {params?.row.nightStatus === 'F' &&
                            <span style={{
                                backgroundColor: color, borderRadius: 50, color: '#fff', fontWeight: 'bold',
                                fontSize: 11, marginLeft: 5, width: 20, height: 20, display: 'inline-flex',
                                alignItems: 'center', justifyContent: 'center'
                            }}>
                                F
                            </span>
                        }

                        {permission && permission.includes('Emp_Auth') && (pages.includes('V3_STATION_DETAIL_REVERT'))
                            && (params?.row.absentReasonNight === 'STATION DETAIL' || params?.row.absentReasonNight === 'Station Detail') &&
                            <img
                                src="/images/revert.png"
                                onClick={() => {
                                    setRevertStation(true)
                                    setRevertData(params?.row)
                                }}
                                width={22}
                                height={22}
                                style={{ cursor: 'pointer', marginLeft: '5px' }}
                            />
                        }
                    </div>
                );
            }
        }
        else if (mode2 === '24') {
            if (!day) {
                if (params?.row?.customShiftsArrayNight?.length > 0) {
                    const selectedShift = Shifts?.find((shift) =>
                        day
                            ? shift.Shift === "Day"
                            : shift.Shift === "Night"
                    );

                    const startTime = selectedShift?.Start_Time;
                    const endTime = selectedShift?.End_Time;

                    const { slots: slotsData, formatMinutes } = getShiftSlots(
                        params?.row?.customShiftsArrayNight,
                        startTime,
                        endTime
                    );
                    const availableTimesFromSlots = slotsData
                        ?.filter(slot => slot.type === 'open')
                        ?.map(slot => `${formatMinutes(slot.start)}-${formatMinutes(slot.end)}`)
                        ?.join(', ');
                    return (
                        <>
                            <div className={`${(params?.row?.customShiftsArrayDay?.length > 0 || params?.row?.customShiftsArrayNight?.length > 0) && 'shift-arr'}`}>
                                {textEmployee}
                                {allowedVars?.V3_ADD_BRACKET_WITH_HOURS_EMP === "true" &&
                                    availableTimesFromSlots && (
                                        <span style={{ marginLeft: 6, fontWeight: 'bold', color: '#079E46' }}>
                                            ({availableTimesFromSlots})
                                        </span>
                                    )
                                }
                            </div>
                            {params?.row?.customShiftsArrayNight?.map((shift) => {
                                reason = shift.absentReason
                                textEmployee = `, Open Position (${varFormatTime(shift.custom_time, user?.Time_Format)})`
                                if (shift.dayStatus == 'F') {
                                    reason = ''
                                    textEmployee = ` ${shift.DayFillEmpEA_Rank} ${shift.DayFillEmpFirst_name} ${shift.DayFillEmpLast_name} (${varFormatTime(shift.custom_time, user?.Time_Format)})`
                                }
                                let color = 'inherit'
                                if (shift.absentColor == 'red') {
                                    color = shift.absentColor || '#E62719'
                                } else if (shift.absentColor == 'orange') {
                                    color = shift.absentColor || 'orange'
                                } else if (shift.absentColor == 'green') {
                                    color = shift.absentColor || '#079E46'
                                } else if (shift.absentColor == 'blue') {
                                    color = shift.absentColor || '#8cbaf9'
                                }
                                return (
                                    <div className={`${(params?.row?.customShiftsArrayDay?.length > 0 || params?.row?.customShiftsArrayNight?.length > 0) && 'shift-arr'}`}
                                        style={{
                                            color: color,
                                            fontWeight: params.row.EA_Status === 'N' ? 'bold' : 'normal',
                                            whiteSpace: 'normal',
                                            wordBreak: 'break-word',
                                            textOverflow: 'ellipsis',
                                        }}>
                                        <span style={{ fontWeight: 'bold' }}>{reason}</span>
                                        {textEmployee}
                                        <span style={{
                                            backgroundColor: color, borderRadius: 50, color: '#fff',
                                            fontWeight: 'bold', fontSize: 11, marginLeft: 5, width: 20,
                                            height: 20, display: 'inline-flex', alignItems: 'center', justifyContent: 'center'
                                        }}>
                                            P{shift.dayStatus}
                                        </span>
                                        {pages.includes('V3_SCHEDULE_QUICK_ASSIGNMENTS') && permission && permission.includes('Emp_Auth') && (
                                            shift.dayStatus == 'O' ? (
                                                <img src="/images/overtime.png"
                                                    onClick={(event) => {
                                                        event.stopPropagation();
                                                        setAssignModal(true);
                                                        setSelectEmployee([params.row.Emp_Code])
                                                        setShift('night')
                                                    }}
                                                    width={30}
                                                    height={30}
                                                    style={{ cursor: 'pointer' }}
                                                />
                                            ) : (
                                                <></>
                                            )
                                        )}
                                        {permission && permission.includes('Emp_Auth') && (pages.includes('V3_STATION_DETAIL_REVERT'))
                                            && (shift.absentReason === 'STATION DETAIL' || shift.absentReason === 'Station Detail') &&
                                            <img
                                                src="/images/revert.png"
                                                onClick={() => {
                                                    setRevertStation(true)
                                                    setRevertData(params?.row)
                                                    setShift('night')
                                                }}
                                                width={22}
                                                height={22}
                                                style={{ cursor: 'pointer', marginLeft: '5px' }}
                                            />
                                        }
                                    </div>
                                )
                            })}

                        </>
                    )
                }
                else {
                    if (params.row.nightStatus === "F" && params.row.NightFillEmpFirst_name) {
                        textEmployee = `${params.row.NightFillEmpEA_Rank} ${params.row.NightFillEmpFirst_name} ${params.row.NightFIllEmpLast_name}`;
                        color = params.row.absentColorNight || '#079E46';
                    }
                    if (params.row.nightStatus === "O") {
                        reason = params.row.absentReasonNight;
                        textEmployee = `, Open Position`;
                        color = params.row.absentColorNight || '#E62719';
                    }
                    if (params.row.nightStatus === "D") {
                        reason = params.row.absentReasonNight;
                        textEmployee = `, Open Position`;
                        color = params.row.absentColorNight || '#000000';
                    }
                    if (params.row.nightStatus === "Q") {
                        reason = params.row.absentReasonNight;
                        textEmployee = `, Open Position`;
                        color = params.row.absentColorNight || '#FFA500';
                    }

                    return (
                        <>
                            {!params.row.nightStatus == " " && allowedVars.V3_SHOW_ORIGINAL_MEMBER_SCHEDULE == "true" &&
                                <span style={{
                                    marginRight: '10px',
                                    color: params.row.nightStatus == 'F' ? '#000000' : params.row.absentColorNight
                                }}>{EmployeeName}</span>
                            }
                            <div className={`${(params?.row?.customShiftsArrayDay?.length > 0 || params?.row?.customShiftsArrayNight?.length > 0) && 'shift-arr'}`}
                                style={{
                                    color: color,
                                    fontWeight: params.row.EA_Status === 'N' ? 'bold' : 'normal',
                                    whiteSpace: 'normal',
                                    wordBreak: 'break-word',
                                    textOverflow: 'ellipsis',
                                }}>
                                <span style={{ fontWeight: 'bold' }}>{reason}</span>
                                {textEmployee}
                                {pages.includes('V3_SCHEDULE_QUICK_ASSIGNMENTS') && permission && permission.includes('Emp_Auth') && (
                                    params.row.absentReasonNight && params.row.nightStatus === 'O' ? (
                                        <img
                                            src="/images/overtime.png"
                                            onClick={(event) => {
                                                event.stopPropagation();
                                                setAssignModal(true);
                                                setSelectEmployee([params.row.Emp_Code])
                                                setShift('night')
                                            }}
                                            width={30}
                                            height={30}
                                            style={{ cursor: 'pointer' }}
                                        />
                                    ) : null
                                )}
                                {permission && permission.includes('Emp_Auth') && (params.row.absentReasonNight && params.row.nightStatus === 'O') && (pages.includes('V3_EMPLOYEE_DROP_DOWN')) ? (
                                    <img
                                        src="/images/assign-image.png"
                                        onClick={(event) => {
                                            event.stopPropagation();
                                            setAssignDataModal(true);
                                            setSelectEmployee([params.row.Emp_Code])
                                            setShift('night')
                                        }}
                                        width={20}
                                        height={20}
                                        style={{ cursor: 'pointer', marginLeft: '10px' }}
                                    />
                                ) : null
                                }

                                {params?.row.nightStatus === 'F' &&
                                    <span style={{
                                        backgroundColor: color, borderRadius: 50, color: '#fff', fontWeight: 'bold',
                                        fontSize: 11, marginLeft: 5, width: 20, height: 20, display: 'inline-flex',
                                        alignItems: 'center', justifyContent: 'center'
                                    }}>
                                        F
                                    </span>
                                }

                                {permission && permission.includes('Emp_Auth') && (pages.includes('V3_STATION_DETAIL_REVERT'))
                                    && (params?.row.absentReasonNight === 'STATION DETAIL' || params?.row.absentReasonNight === 'Station Detail') &&
                                    <img
                                        src="/images/revert.png"
                                        onClick={() => {
                                            setRevertStation(true)
                                            setRevertData(params?.row)
                                            setShift('night')
                                        }}
                                        width={22}
                                        height={22}
                                        style={{ cursor: 'pointer', marginLeft: '5px' }}
                                    />
                                }
                            </div>
                        </>
                    );
                }
            }
            else {
                if (params?.row?.customShiftsArrayDay?.length > 0) {
                    const selectedShift = Shifts?.find((shift) =>
                        day
                            ? shift.Shift === "Day"
                            : shift.Shift === "Night" || shift.Shift === "24"
                    );

                    const startTime = selectedShift?.Start_Time;
                    const endTime = selectedShift?.End_Time;
                    const { slots: slotsData, formatMinutes } = getShiftSlots(
                        params?.row?.customShiftsArrayDay,
                        startTime,
                        endTime
                    );
                    const availableTimesFromSlots = slotsData
                        ?.filter(slot => slot.type === 'open')
                        ?.map(slot => `${formatMinutes(slot.start)}-${formatMinutes(slot.end)}`)
                        ?.join(', ');
                    return (
                        <>
                            <div className={`${(params?.row?.customShiftsArrayDay?.length > 0 || params?.row?.customShiftsArrayNight?.length > 0) && 'shift-arr'}`}>
                                {textEmployee}
                                {allowedVars?.V3_ADD_BRACKET_WITH_HOURS_EMP === "true" &&
                                    availableTimesFromSlots && (
                                        <span style={{ marginLeft: 6, fontWeight: 'bold', color: '#079E46' }}>
                                            ({availableTimesFromSlots})
                                        </span>
                                    )
                                }
                            </div>
                            {params?.row?.customShiftsArrayDay?.map((shift) => {
                                reason = shift.absentReason
                                textEmployee = `, Open Position (${varFormatTime(shift.custom_time, user?.Time_Format)})`
                                if (shift.dayStatus == 'F') {
                                    reason = ''
                                    textEmployee = `${shift.DayFillEmpEA_Rank}  ${shift.DayFillEmpFirst_name} ${shift.DayFIllEmpLast_name} (${varFormatTime(shift.custom_time, user?.Time_Format)})`
                                }
                                let color = 'inherit'
                                if (shift.absentColor == 'red') {
                                    color = shift.absentColor || '#E62719'
                                } else if (shift.absentColor == 'orange') {
                                    color = shift.absentColor || 'orange'
                                } else if (shift.absentColor == 'green') {
                                    color = shift.absentColor || '#079E46'
                                } else if (shift.absentColor == 'blue') {
                                    color = shift.absentColor || '#8cbaf9'
                                }
                                return (
                                    <div className={`${(params?.row?.customShiftsArrayDay?.length > 0 || params?.row?.customShiftsArrayNight?.length > 0) && 'shift-arr'}`}
                                        style={{
                                            color: color,
                                            fontWeight: params.row.EA_Status === 'N' ? 'bold' : 'normal',
                                            whiteSpace: 'normal',
                                            wordBreak: 'break-word',
                                            textOverflow: 'ellipsis',
                                        }}>
                                        <span style={{ fontWeight: 'bold' }}>{reason}</span>
                                        {textEmployee}
                                        <span style={{
                                            backgroundColor: color, borderRadius: 50, color: '#fff',
                                            fontWeight: 'bold', fontSize: 11, marginLeft: 5, width: 20,
                                            height: 20, display: 'inline-flex', alignItems: 'center', justifyContent: 'center'
                                        }}>
                                            P{shift.dayStatus}
                                        </span>
                                        {pages.includes('V3_SCHEDULE_QUICK_ASSIGNMENTS') && permission && permission.includes('Emp_Auth') && (
                                            shift.dayStatus == 'O' ? (
                                                <img src="/images/overtime.png"
                                                    onClick={(event) => {
                                                        event.stopPropagation();
                                                        setAssignModal(true);
                                                        setSelectEmployee([params.row.Emp_Code])
                                                        setShift('day')
                                                    }}
                                                    width={30}
                                                    height={30}
                                                    style={{ cursor: 'pointer' }}
                                                />
                                            ) : (
                                                <></>
                                            )
                                        )}
                                        {permission && permission.includes('Emp_Auth') && (pages.includes('V3_STATION_DETAIL_REVERT'))
                                            && (shift.absentReason === 'STATION DETAIL' || shift.absentReason === 'Station Detail') &&
                                            <img
                                                src="/images/revert.png"
                                                onClick={() => {
                                                    setRevertStation(true)
                                                    setRevertData(params?.row)
                                                    setShift('day')
                                                }}
                                                width={22}
                                                height={22}
                                                style={{ cursor: 'pointer', marginLeft: '5px' }}
                                            />
                                        }
                                    </div>
                                )
                            })}
                        </>
                    )
                }
                else {
                    if (params.row.dayStatus === "F" && params.row.DayFillEmpFirst_name) {
                        textEmployee = `${params.row.DayFillEmpEA_Rank} ${params.row.DayFillEmpFirst_name} ${params.row.DayFIllEmpLast_name}`;
                        color = params.row.absentColor || '#079E46';
                    }
                    if (params.row.dayStatus === "O") {
                        reason = params.row.absentReason;
                        textEmployee = `, Open Position`;
                        color = params.row.absentColor || '#E62719';
                    }
                    if (params.row.dayStatus === "D") {
                        reason = params.row.absentReason;
                        textEmployee = `, Open Position`;
                        color = params.row.absentColor || '#000000';
                    }
                    if (params.row.dayStatus === "Q") {
                        reason = params.row.absentReason;
                        textEmployee = `, Open Position`;
                        color = params.row.absentColor || '#FFA500';
                    }

                    return (
                        <>
                            {!params.row.dayStatus == " " && allowedVars.V3_SHOW_ORIGINAL_MEMBER_SCHEDULE == "true" &&
                                <span style={{
                                    marginRight: '10px',
                                    color: params.row.dayStatus == 'F' ? '#000000' : params.row.absentColor
                                }}>
                                    {EmployeeName}</span>
                            }
                            <div className={`${(params?.row?.customShiftsArrayDay?.length > 0 || params?.row?.customShiftsArrayNight?.length > 0) && 'shift-arr'}`}
                                style={{
                                    color: color,
                                    fontWeight: params.row.EA_Status === 'N' ? 'bold' : 'normal',
                                    whiteSpace: 'normal',
                                    wordBreak: 'break-word',
                                    textOverflow: 'ellipsis',
                                }}>
                                <span style={{ fontWeight: 'bold' }}>{reason}</span>
                                {textEmployee}
                                {pages.includes('V3_SCHEDULE_QUICK_ASSIGNMENTS') && permission && permission.includes('Emp_Auth') && (
                                    params.row.absentReason && params.row.dayStatus === 'O' ? (
                                        <img
                                            src="/images/overtime.png"
                                            onClick={(event) => {
                                                event.stopPropagation();
                                                setAssignModal(true);
                                                setSelectEmployee([params.row.Emp_Code])
                                                setShift('day')
                                            }}
                                            width={30}
                                            height={30}
                                            style={{ cursor: 'pointer' }}
                                        />
                                    ) : null
                                )}
                                {permission && permission.includes('Emp_Auth') && (params.row.absentReason && params.row.dayStatus === 'O') && (pages.includes('V3_EMPLOYEE_DROP_DOWN')) ? (
                                    <img
                                        src="/images/assign-image.png"
                                        onClick={(event) => {
                                            event.stopPropagation();
                                            setAssignDataModal(true);
                                            setSelectEmployee([params.row.Emp_Code])
                                            setShift('day')
                                        }}
                                        width={20}
                                        height={20}
                                        style={{ cursor: 'pointer', marginLeft: '10px' }}
                                    />
                                ) : null
                                }

                                {params?.row.dayStatus === 'F' &&
                                    <span style={{
                                        backgroundColor: color, borderRadius: 50, color: '#fff', fontWeight: 'bold',
                                        fontSize: 11, marginLeft: 5, width: 20, height: 20, display: 'inline-flex',
                                        alignItems: 'center', justifyContent: 'center'
                                    }}>
                                        F
                                    </span>
                                }

                                {permission && permission.includes('Emp_Auth') && (pages.includes('V3_STATION_DETAIL_REVERT')) &&
                                    (params?.row.absentReason === 'STATION DETAIL' || params?.row.absentReason === 'Station Detail') &&
                                    <img
                                        src="/images/revert.png"
                                        onClick={() => {
                                            setRevertStation(true)
                                            setRevertData(params?.row)
                                            setShift('day')
                                        }}
                                        width={22}
                                        height={22}
                                        style={{ cursor: 'pointer', marginLeft: '5px' }}
                                    />
                                }
                            </div>
                        </>
                    );
                }
            }
        }
        else {
            if (params?.row?.customShiftsArrayDay?.length > 0) {
                const selectedShift = Shifts?.find((shift) =>
                    day
                        ? shift.Shift === "Day"
                        : shift.Shift === "Night" || shift.Shift === "24"
                );

                const startTime = selectedShift?.Start_Time;
                const endTime = selectedShift?.End_Time;
                const { slots: slotsData, formatMinutes } = getShiftSlots(
                    params?.row?.customShiftsArrayDay,
                    startTime,
                    endTime
                );
                const availableTimesFromSlots = slotsData
                    ?.filter(slot => slot.type === 'open')
                    ?.map(slot => `${formatMinutes(slot.start)}-${formatMinutes(slot.end)}`)
                    ?.join(', ');
                return (
                    <>
                        <div className={`${(params?.row?.customShiftsArrayDay?.length > 0 || params?.row?.customShiftsArrayNight?.length > 0) && 'shift-arr'}`}>
                            {textEmployee}
                            {allowedVars?.V3_ADD_BRACKET_WITH_HOURS_EMP === "true" &&
                                availableTimesFromSlots && (
                                    <span style={{ marginLeft: 6, fontWeight: 'bold', color: '#079E46' }}>
                                        ({availableTimesFromSlots})
                                    </span>
                                )
                            }
                        </div>

                        {params?.row?.customShiftsArrayDay?.map((shift) => {
                            reason = shift.absentReason
                            textEmployee = `, Open Position (${varFormatTime(shift.custom_time, user?.Time_Format)})`
                            if (shift.dayStatus == 'F') {
                                reason = ''
                                textEmployee = `${shift.DayFillEmpEA_Rank}  ${shift.DayFillEmpFirst_name} ${shift.DayFIllEmpLast_name} (${varFormatTime(shift.custom_time, user?.Time_Format)})`
                            }
                            let color = 'inherit'
                            if (shift.absentColor == 'red') {
                                color = shift.absentColor || '#E62719'
                            } else if (shift.absentColor == 'orange') {
                                color = shift.absentColor || 'orange'
                            } else if (shift.absentColor == 'green') {
                                color = shift.absentColor || '#079E46'
                            } else if (shift.absentColor == 'blue') {
                                color = shift.absentColor || '#8cbaf9'
                            }
                            return (
                                <div className={`${(params?.row?.customShiftsArrayDay?.length > 0 || params?.row?.customShiftsArrayNight?.length > 0) && 'shift-arr'}`}
                                    style={{
                                        color: color,
                                        fontWeight: params.row.EA_Status === 'N' ? 'bold' : 'normal',
                                        whiteSpace: 'normal',
                                        wordBreak: 'break-word',
                                        textOverflow: 'ellipsis',
                                    }}>
                                    <span style={{ fontWeight: 'bold' }}>{reason}</span>
                                    {textEmployee}
                                    <span style={{
                                        backgroundColor: color, borderRadius: 50, color: '#fff',
                                        fontWeight: 'bold', fontSize: 11, marginLeft: 5, width: 20,
                                        height: 20, display: 'inline-flex', alignItems: 'center', justifyContent: 'center'
                                    }}>
                                        P{shift.dayStatus}
                                    </span>
                                    {pages.includes('V3_SCHEDULE_QUICK_ASSIGNMENTS') && permission && permission.includes('Emp_Auth') && (
                                        shift.dayStatus == 'O' ? (
                                            <img src="/images/overtime.png"
                                                onClick={(event) => {
                                                    event.stopPropagation();
                                                    setAssignModal(true);
                                                    setSelectEmployee([params.row.Emp_Code])
                                                }}
                                                width={30}
                                                height={30}
                                                style={{ cursor: 'pointer' }}
                                            />
                                        ) : (
                                            <></>
                                        )
                                    )}
                                    {permission && permission.includes('Emp_Auth') && (pages.includes('V3_STATION_DETAIL_REVERT'))
                                        && (shift.absentReason === 'STATION DETAIL' || shift.absentReason === 'Station Detail') &&
                                        <img
                                            src="/images/revert.png"
                                            onClick={() => {
                                                setRevertStation(true)
                                                setRevertData(params?.row)
                                            }}
                                            width={22}
                                            height={22}
                                            style={{ cursor: 'pointer', marginLeft: '5px' }}
                                        />
                                    }
                                </div>
                            )
                        })}
                    </>
                )
            }
            else {
                if (params.row.dayStatus === "F" && params.row.DayFillEmpFirst_name) {
                    textEmployee = `${params.row.DayFillEmpEA_Rank} ${params.row.DayFillEmpFirst_name} ${params.row.DayFIllEmpLast_name}`;
                    color = params.row.absentColor || '#079E46';
                }
                if (params.row.dayStatus === "O") {
                    reason = params.row.absentReason;
                    textEmployee = `, Open Position`;
                    color = params.row.absentColor || '#E62719';
                }
                if (params.row.dayStatus === "D") {
                    reason = params.row.absentReason;
                    textEmployee = `, Open Position`;
                    color = params.row.absentColor || '#000000';
                }
                if (params.row.dayStatus === "Q") {
                    reason = params.row.absentReason;
                    textEmployee = `, Open Position`;
                    color = params.row.absentColor || '#FFA500';
                }

                return (
                    <div className={`${(params?.row?.customShiftsArrayDay?.length > 0 || params?.row?.customShiftsArrayNight?.length > 0) && 'shift-arr'}`}
                        style={{
                            color: color,
                            fontWeight: params.row.EA_Status === 'N' ? 'bold' : 'normal',
                            whiteSpace: 'normal',
                            wordBreak: 'break-word',
                            textOverflow: 'ellipsis',
                        }}>
                        {!params.row.dayStatus == " " && allowedVars.V3_SHOW_ORIGINAL_MEMBER_SCHEDULE == "true" &&
                            <span
                                style={{
                                    marginRight: '10px',
                                    color: params.row.dayStatus == 'F' ? '#000000' : params.row.absentColor
                                }}>
                                {EmployeeName}
                            </span>
                        }
                        {!params.row.dayStatus == " " && allowedVars.V3_SHOW_ORIGINAL_MEMBER_SCHEDULE == "true" &&
                            <img src='/images/right-arrow-new.svg' height={'16px'} width={'16px'} style={{ marginRight: '10px' }} />
                        }
                        <span style={{ fontWeight: 'bold' }}>{reason}</span>
                        {textEmployee}
                        {pages.includes('V3_SCHEDULE_QUICK_ASSIGNMENTS') && permission && permission.includes('Emp_Auth') && (
                            params.row.absentReason && params.row.dayStatus === 'O' ? (
                                <img
                                    src="/images/overtime.png"
                                    onClick={(event) => {
                                        event.stopPropagation();
                                        setAssignModal(true);
                                        setSelectEmployee([params.row.Emp_Code])
                                    }}
                                    width={30}
                                    height={30}
                                    style={{ cursor: 'pointer' }}
                                />
                            ) : null
                        )}
                        {permission && permission.includes('Emp_Auth') && (params.row.absentReason && params.row.dayStatus === 'O') && (pages.includes('V3_EMPLOYEE_DROP_DOWN')) ? (
                            <img
                                src="/images/assign-image.png"
                                onClick={(event) => {
                                    event.stopPropagation();
                                    setAssignDataModal(true);
                                    setSelectEmployee([params.row.Emp_Code])
                                }}
                                width={22}
                                height={22}
                                style={{ cursor: 'pointer', marginLeft: '10px' }}
                            />
                        ) : null
                        }

                        {params?.row.dayStatus === 'F' &&
                            <span style={{
                                backgroundColor: color, borderRadius: 50, color: '#fff', fontWeight: 'bold',
                                fontSize: 11, marginLeft: 5, width: 20, height: 20, display: 'inline-flex',
                                alignItems: 'center', justifyContent: 'center'
                            }}>
                                F
                            </span>
                        }

                        {permission && permission.includes('Emp_Auth') && (pages.includes('V3_STATION_DETAIL_REVERT'))
                            && (params.row.absentReason === 'STATION DETAIL' || params.row.absentReason === 'Station Detail') &&
                            <img
                                src="/images/revert.png"
                                onClick={() => {
                                    setRevertStation(true)
                                    setRevertData(params?.row)
                                }}
                                width={22}
                                height={22}
                                style={{ cursor: 'pointer', marginLeft: '5px' }}
                            />
                        }
                    </div>
                );
            }
        }
    }

    const options = PossitionListDDL.map((i) => ({
        value: i.SO_Value,
        label: i.SO_Desc,
        dataAssignment: i?.resource_assignment,
    }));

    const reformatColumns = (notAbsentDay, totalDay, notAbsentNight = null, totalNight = null, day = null, minimumDayStaff, minimumNightStaff) => {
        const isShortView = pages.includes('V3_SCHEDULE_DN_TOGGLE_SHORTEN_VIEW');
        let columns = [
            {
                field: 'PositionName',
                headerName: 'Unit',
                flex: 1,
                minWidth: minWidth,
                maxWidth: maxWidth,
                filterable: false,
                renderCell: (params) => {
                    const isOfficerHighlighted =
                        v3Data?.SCHEDULE_HIGHTLIGHT_OFFICERS_TEXT && params?.row?.is_officer === true &&
                        (v3Data?.SCHEDULE_HIGHLIGHT_OFFICERS || v3Data?.SCHEDULE_HIGHLIGHT_OFFICERS === 'true')
                    const defaultOption = options.find((opt) => opt.value === params.row.Position_Code);
                    const engine = `${defaultOption?.label.split(' ')[0]} ${defaultOption?.label.split(' ')[1]}`
                    var bg = '#e9e9ed'
                    if (pages.includes('V3_STAFF_COLOR_BORDERS')) {
                        bg = '#1AF10A4D';
                        if (day) {
                            if (Object.values(emptyOfficers).includes(engine)) {
                                bg = '#E6271926'
                            }
                            else {
                                if (currentVehicleCounts[params.row.Vehicle_Code] < parseInt(requiredVehicleCounts[params.row.Vehicle_Code]?.min)) {
                                    bg = '#E6271926'
                                }
                                else if (currentVehicleCounts[params.row.Vehicle_Code] > parseInt(requiredVehicleCounts[params.row.Vehicle_Code]?.max)) {
                                    bg = '#0D6EFD4D'
                                }
                            }
                        }
                        else {
                            if (Object.values(emptyOfficersNight).includes(engine)) {
                                bg = '#E6271926'
                            }
                            else {
                                if (currentVehicleCountsNight[params.row.Vehicle_Code] < parseInt(requiredVehicleCounts[params.row.Vehicle_Code]?.min)) {
                                    bg = '#E6271926'
                                }
                                else if (currentVehicleCountsNight[params.row.Vehicle_Code] > parseInt(requiredVehicleCounts[params.row.Vehicle_Code]?.max)) {
                                    bg = '#0D6EFD4D'
                                }
                            }
                        }
                    }
                    if (pages.includes('SCHEDULE_SELECT_POSITION_DAY_NIGHT')) {
                        return (
                            <div style={{ display: 'flex', fontWeight: isOfficerHighlighted ? 'bold' : 'normal' }}>
                                {pages && pages.includes('V3_VEHICLE_ASSIGNMENT') &&
                                    <div
                                        className={`d-flex justify-content-center align-items-center`}
                                        style={{ marginRight: '20px' }}
                                    >
                                        <img src={
                                            (["DC", "BC"].includes(params?.row?.Vehicle_Code))
                                                ?
                                                "/images/DeputyCar.png"
                                                :
                                                // ["E1", "E2", "E3"].includes(params?.row?.Vehicle_Code) 
                                                params?.row?.Vehicle_Code?.charAt(0) == "E"
                                                    ?
                                                    "/images/EngineIcon.png"
                                                    :
                                                    params?.row?.Vehicle_Code?.charAt(0) == "R"
                                                        ?
                                                        "/images/ambulance_icon.png"
                                                        :
                                                        params?.row?.Vehicle_Code?.charAt(0) == "F"
                                                            ?
                                                            "/images/fire-boat.png"
                                                            :
                                                            "/images/TowerLAdderIcon.png"
                                        }
                                            className='m-auto'
                                            style={{ cursor: 'pointer', width: '30px', height: '30px' }}
                                            onClick={() => setOverTimeModal(true)}
                                        />
                                        <div style={{ width: '16px', marginLeft: '8px', marginTop: '6px' }}>
                                            <b>{params?.row?.Vehicle_Code}</b>
                                        </div>
                                    </div>
                                }
                                <div
                                    className={`d-flex flex-column justify-content-center ${(params?.row?.customShiftsArrayDay?.length > 0 || params?.row?.customShiftsArrayNight?.length > 0) && 'shift-arr'}`}
                                    style={{ maxHeight: '60vh', overflow: 'auto', msOverflowStyle: 'none', scrollbarWidth: 'none' }}
                                >

                                    <form className='d-flex flex-nowrap mt-1'>
                                        <>
                                            <CustomSelect
                                                options={options}
                                                defaultOption={defaultOption}
                                                isDisabled={isDisabled || !permission?.includes('Emp_Auth')}
                                                isLoading={isLoading}
                                                isRtl={isRtl}
                                                isSearchable={isSearchable}
                                                name="Possition"
                                                onChange={(e) => handleSelectChange(e, params?.row, day)}
                                                bgColor={allowedVars?.V3_TRUCK_COLORS_POSITION ? params?.row?.Truck_Color : bg}
                                                mode2={mode2}
                                                value={defaultOption}
                                                hideIndicator={!permission?.includes('Emp_Auth')}
                                            />
                                        </>
                                        <button
                                            disabled={positionLoading}
                                            className='btn btn-outline-primary mb-1'
                                            style={{ marginLeft: '10px', display: "none" }}
                                            type='hide' >&#x2714;
                                        </button>
                                    </form>
                                </div>
                            </div>
                        );
                    }
                    else {
                        return <div className={`d-flex align-items-center ${(params?.row?.customShiftsArrayDay?.length > 0 || params?.row?.customShiftsArrayNight?.length > 0) && 'shift-arr'}`} style={{ minHeight: '60px', fontWeight: isOfficerHighlighted ? 'bold' : 'normal' }} >{params.row.PositionName}</div>;
                    }
                }
            },
            {
                field: 'fullName',
                headerName: 'Name',
                flex: 1,
                minWidth: (is_dn_deparment === 'DN_TOGGLE' && pages.includes('V3_SCHEDULE_DN_TOGGLE_SHORTEN_VIEW')) ? 220 : 120,
                renderCell: (params) => {
                    const isCompact = mode2 === '24';
                    const isOfficerHighlighted =
                        v3Data?.SCHEDULE_HIGHTLIGHT_OFFICERS_TEXT && params?.row?.is_officer === true &&
                        (v3Data?.SCHEDULE_HIGHLIGHT_OFFICERS || v3Data?.SCHEDULE_HIGHLIGHT_OFFICERS === 'true')
                    return (
                        <div className='large-creensize'
                            style={{
                                fontSize: isCompact ? '12px' : '14px',
                                whiteSpace: isCompact ? 'nowrap' : 'normal',
                                overflow: isCompact ? 'hidden' : 'visible',
                                textOverflow: isCompact ? 'ellipsis' : 'unset',
                                wordBreak: isCompact ? 'normal' : 'break-word',
                                lineHeight: '1.2',
                                display: 'block',
                                width: '100%',
                                padding: '4px 0',
                                fontWeight: isOfficerHighlighted ? 'bold' : 'normal',
                            }}
                        >
                            {pages.includes('V3_SCHEDULE_DN_TOGGLE_SHORTEN_VIEW')
                                ? getEmpNameStyle(params, day)
                                : `${params.row.EA_Rank} ${params.row.fullName}`}
                        </div>
                    );
                },
                filterOperators: getGridStringOperators().filter((operator) => operator.value === "contains"),
            },
        ];

        if (is_dn_deparment == '24_FULL_VIEW') {
            columns.push(
                {
                    field: 'inDayShift',
                    headerName: 'Day',
                    filterable: false,
                    renderCell: (params) => {
                        let textEmployee = `${params.row.EA_Rank} ${params.row.fullName}`
                        const colorMap = {
                            red: { color: 'white', background: '#E62719' },
                            orange: { color: 'black', background: 'orange' },
                            green: { color: 'white', background: '#079E46' },
                            blue: { color: 'black', background: '#8cbaf9' },
                        };
                        if (params?.row?.customShiftsArrayDay?.length > 0) {
                            return (
                                <>
                                    {params?.row?.customShiftsArrayDay?.map((shift) => {
                                        textEmployee = `${shift.absentReason} (${varFormatTime(shift.custom_time, user?.Time_Format)})`
                                        if (shift.dayStatus == 'F') {
                                            textEmployee = `${shift.absentReason} (${shift.DayFillEmpEA_Rank} ${shift.DayFillEmpFirst_name} ${shift.DayFIllEmpLast_name})(${varFormatTime(shift.custom_time, user?.Time_Format)})`
                                        }
                                        const { color = 'white', background = 'black' } = colorMap[shift.absentColor] || { color: shift.absentTextColor, background: shift.absentColor };
                                        return (
                                            <div className='custom-cell my-1'>
                                                <Chip
                                                    sx={{
                                                        height: 'auto',
                                                        '& .MuiChip-label': {
                                                            display: 'block',
                                                            whiteSpace: 'normal',
                                                        },
                                                    }}
                                                    style={{ textAlign: 'center', padding: '6px 0px', width: '100%', background, color, cursor: 'pointer' }}
                                                    label={textEmployee}
                                                />
                                            </div>
                                        )
                                    })}
                                </>
                            )
                        }
                        else if (params.row.absentReason) {
                            textEmployee = params.row.absentReason
                            if ((params.row.dayStatus == "F" || params.row.dayStatus == "R") && params.row.DayFillEmpFirst_name) {
                                textEmployee = `${params.row.absentReason} (${params.row.DayFillEmpEA_Rank} ${params.row.DayFillEmpFirst_name} ${params.row.DayFIllEmpLast_name})`;
                            }

                            const { color = 'white', background = 'black' } = colorMap[params.row.absentColor] || { color: params.row.absentTextColor, background: params.row.absentColor };
                            return (
                                <Chip
                                    sx={{
                                        height: 'auto',
                                        '& .MuiChip-label': {
                                            display: 'block',
                                            whiteSpace: 'normal',
                                        },
                                    }}
                                    style={{ textAlign: 'center', padding: '6px 0px', width: '100%', background, color, cursor: 'pointer' }}
                                    label={textEmployee}
                                />
                            );
                        } else {
                            return (
                                <>
                                    {permission && permission.includes('Emp_Auth') && (
                                        <img src="/images/three-dot-menu.svg" className='m-auto' style={{ cursor: 'pointer' }} onClick={() => setOverTimeModal(true)} />
                                    )}
                                </>
                            );
                        }
                    },
                    flex: 1,
                    minWidth: 120
                },
            );
            columns.push(
                {
                    field: 'inNIGHTShift',
                    headerName: 'Night',
                    filterable: false,
                    renderCell: (params) => {
                        let textEmployee = `${params.row.EA_Rank} ${params.row.fullName}`
                        const colorMap = {
                            red: { color: 'white', background: '#E62719' },
                            orange: { color: 'black', background: 'orange' },
                            green: { color: 'white', background: '#079E46' },
                            blue: { color: 'black', background: '#8cbaf9' },
                        };
                        if (params?.row?.customShiftsArrayNight?.length > 0) {
                            return (
                                <>
                                    {params?.row?.customShiftsArrayNight?.map((shift) => {
                                        textEmployee = `${shift.absentReason} (${varFormatTime(shift.custom_time, user?.Time_Format)})`
                                        if (shift.nightStatus == 'F') {
                                            textEmployee = `${shift.absentReason} (${shift.NightFillEmpEA_Rank} ${shift.NightFillEmpFirst_name} ${shift.NightFIllEmpLast_name}) (${varFormatTime(shift.custom_time, user?.Time_Format)})`
                                        }
                                        const { color = 'white', background = 'black' } = colorMap[shift.absentColor] || { color: shift.absentTextColor, background: shift.absentColor };
                                        return (
                                            <div className='custom-cell my-1'>
                                                <Chip
                                                    sx={{
                                                        height: 'auto',
                                                        '& .MuiChip-label': {
                                                            display: 'block',
                                                            whiteSpace: 'normal',
                                                        },
                                                    }}
                                                    style={{ textAlign: 'center', padding: '6px 0px', width: '100%', background, color, cursor: 'pointer' }}
                                                    label={textEmployee}
                                                />
                                            </div>
                                        )
                                    })}
                                </>
                            )
                        }
                        else if (params.row.absentReasonNight) {
                            textEmployee = params.row.absentReasonNight
                            if ((params.row.nightStatus == "F" || params.row.nightStatus == "R") && params.row.NightFillEmpFirst_name) {
                                textEmployee = `${params.row.absentReasonNight} (${params.row.NightFillEmpEA_Rank} ${params.row.NightFillEmpFirst_name} ${params.row.NightFIllEmpLast_name}) `;
                            }
                            const { color = 'white', background = 'black' } = colorMap[params.row.absentColorNight] || { color: params.row.absentTextColorNight, background: params.row.absentColorNight };

                            return (
                                <Chip
                                    sx={{
                                        height: 'auto',
                                        '& .MuiChip-label': {
                                            display: 'block',
                                            whiteSpace: 'normal',
                                        },
                                    }}
                                    style={{ textAlign: 'center', padding: '6px 0px', width: '100%', background, color, cursor: 'pointer' }}
                                    label={textEmployee}
                                />
                            );
                        } else {
                            return (
                                <>
                                    {permission && permission.includes('Emp_Auth') &&
                                        <img src="/images/three-dot-menu.svg" className='m-auto' style={{ cursor: 'pointer' }} onClick={() => setOverTimeModal(true)} />
                                    }
                                </>
                            );
                        }
                    },
                    flex: 1,
                    minWidth: 120
                }
            )
        }
        else if ((is_dn_deparment == 'DN_24_VIEW') || (is_dn_deparment == 'DN_TOGGLE' && mode2 == '24')) {
            columns = columns.concat(
                (day !== null && day === false) || (day !== null && isNightShift) ? [
                    {
                        field: 'inNIGHTShift',
                        headerName: 'Night',
                        filterable: false,
                        renderCell: (params) => {
                            if (mode2 === '24' && pages.includes('V3_SCHEDULE_DN_TOGGLE_SHORTEN_VIEW')) {
                                return (
                                    <div
                                        style={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer' }}
                                        onClick={(event) => {
                                            if (permission && permission.includes('Emp_Auth')) {
                                                event.stopPropagation();
                                                setOverTimeModal(true);
                                                setSelectEmployee([params.row.Emp_Code]);
                                            }
                                        }}
                                    >
                                        {permission && permission.includes('Emp_Auth') && (
                                            <img
                                                src="/images/three-dot-menu.svg"
                                                className="m-auto"
                                                style={{ cursor: 'pointer' }}
                                                onClick={(event) => {
                                                    event.stopPropagation();
                                                    setOverTimeModal(true);
                                                    setSelectEmployee([params.row.Emp_Code]);
                                                }}
                                            />
                                        )}
                                    </div>
                                );
                            }
                            else {
                                if (params.row.absentReasonNight || params?.row?.customShiftsArrayNight?.length > 0) {
                                    let textEmployee = '';
                                    if ((params.row.nightStatus == "F" || params.row.nightStatus == "R") && params.row.NightFillEmpFirst_name) {
                                        textEmployee = ' (' + params.row.NightFillEmpEA_Rank + ' ' + params.row.NightFillEmpFirst_name + ' ' + params.row.NightFIllEmpLast_name + ')'
                                    }
                                    let color = 'white'
                                    let background = 'black'
                                    if (params.row.absentColorNight == 'red') {
                                        color = 'white'
                                        background = '#E62719'
                                    } else if (params.row.absentColorNight == 'orange') {
                                        color = 'black'
                                        background = 'orange'
                                    } else if (params.row.absentColorNight == 'green') {
                                        color = 'white'
                                        background = '#079E46'
                                    } else if (params.row.absentColorNight == 'blue') {
                                        color = 'black'
                                        background = '#8cbaf9'
                                    }
                                    else {
                                        background = params.row.absentColorNight
                                    }
                                    return (
                                        <>
                                            {params?.row?.customShiftsArrayNight?.length > 0 && params?.row?.customShiftsArrayNight?.map((shift) => {
                                                let color = 'white'
                                                let background = 'black'
                                                if (shift.absentColor == 'red') {
                                                    color = 'white'
                                                    background = '#E62719'
                                                } else if (shift.absentColor == 'orange') {
                                                    color = 'black'
                                                    background = 'orange'
                                                } else if (shift.absentColor == 'green') {
                                                    color = 'white'
                                                    background = '#079E46'
                                                } else if (shift.absentColor == 'blue') {
                                                    color = 'black'
                                                    background = '#8cbaf9'
                                                }
                                                else {
                                                    background = shift.absentColorNight
                                                }
                                                return (
                                                    <div className='shift-arr'>
                                                        <Chip sx={{
                                                            height: 'auto',
                                                            '& .MuiChip-label': {
                                                                display: 'block',
                                                                whiteSpace: 'normal',
                                                            },
                                                        }}
                                                            style={{ textAlign: 'center', padding: '6px 0px', width: '100%', background: background, color: color }}
                                                            label={`${shift.absentReason} ${shift.DayFillEmpFirst_name && `(${shift.DayFillEmpEA_Rank} ${shift.DayFillEmpFirst_name} ${shift.DayFillEmpLast_name})`} (${varFormatTime(shift.custom_time, user?.Time_Format)})`}
                                                            onClick={(event) => {
                                                                if(permission && permission.includes('Emp_Auth')){
                                                                    event.stopPropagation();
                                                                    setOverTimeModal(true);
                                                                    setSelectEmployee([params.row.Emp_Code]);
                                                                }
                                                            }}
                                                        />
                                                    </div>
                                                )
                                            })}
                                            {params.row.absentReasonNight &&
                                                <Chip
                                                    sx={{
                                                        height: 'auto',
                                                        '& .MuiChip-label': {
                                                            display: 'block',
                                                            whiteSpace: 'normal',
                                                        },
                                                    }}
                                                    style={{ textAlign: 'center', padding: '6px 0px', width: '100%', background: background, color: color, cursor: 'pointer' }}
                                                    label={params.row.inNIGHTShift ? params.row.absentReasonNight + textEmployee : params.row.absentReasonNight}
                                                    onClick={(event) => {
                                                        if(permission && permission.includes('Emp_Auth')){
                                                            event.stopPropagation();
                                                            setOverTimeModal(true);
                                                            setIsOnlyNightEmployee(true)
                                                            setSelectEmployee([params.row.Emp_Code]);
                                                        }
                                                    }}
                                                />
                                            }
                                        </>
                                    );
                                }
                                else {
                                    return (
                                        <>
                                            <div
                                                style={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer' }}
                                                onClick={(event) => {
                                                    if (permission && permission.includes('Emp_Auth')) {
                                                        event.stopPropagation();
                                                        setIsOnlyNightEmployee(true);
                                                        setOverTimeModal(true);
                                                        setSelectEmployee([params.row.Emp_Code]);
                                                    }
                                                }}
                                            >
                                                {permission && permission.includes('Emp_Auth') && (
                                                    <img
                                                        src="/images/three-dot-menu.svg"
                                                        className="m-auto"
                                                        style={{ cursor: 'pointer' }}
                                                        onClick={(event) => {
                                                            event.stopPropagation();
                                                            setIsOnlyNightEmployee(true);
                                                            setOverTimeModal(true);
                                                            setSelectEmployee([params.row.Emp_Code]);
                                                        }}
                                                    />
                                                )}
                                            </div>
                                        </>
                                    )
                                }
                            }
                            return (<span>{params.row.inNIGHTShift ? '' : 'X'}</span>);
                        },
                        flex: 1,
                        minWidth: isShortView ? undefined : 120,
                        maxWidth: isShortView ? 60 : undefined,
                    },
                ]
                    : [
                        {
                            field: 'inDayShift',
                            headerName: 'Day',
                            filterable: false,
                            renderCell: (params) => {
                                if (mode2 === '24' && pages.includes('V3_SCHEDULE_DN_TOGGLE_SHORTEN_VIEW')) {
                                    return (
                                        <div
                                            style={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer' }}
                                            onClick={(event) => {
                                                if (permission && permission.includes('Emp_Auth')) {
                                                    event.stopPropagation();
                                                    setOverTimeModal(true);
                                                    setSelectEmployee([params.row.Emp_Code]);
                                                }
                                            }}
                                        >
                                            {permission && permission.includes('Emp_Auth') && (
                                                <img
                                                    src="/images/three-dot-menu.svg"
                                                    className="m-auto"
                                                    style={{ cursor: 'pointer' }}
                                                    onClick={(event) => {
                                                        event.stopPropagation();
                                                        setOverTimeModal(true);
                                                        setSelectEmployee([params.row.Emp_Code]);
                                                    }}
                                                />
                                            )}
                                        </div>
                                    );
                                }
                                else {
                                    if (params.row.absentReason || params?.row?.customShiftsArrayDay?.length > 0) {
                                        let textEmployee = '';
                                        if ((params.row.dayStatus == "F" || params.row.dayStatus == "R") && params.row.DayFillEmpFirst_name) {
                                            textEmployee = ' (' + params.row.DayFillEmpEA_Rank + ' ' + params.row.DayFillEmpFirst_name + ' ' + params.row.DayFIllEmpLast_name + ')'
                                        }
                                        let color = 'white'
                                        let background = 'black'
                                        if (params.row.absentColor == 'red') {
                                            color = 'white'
                                            background = '#E62719'
                                        } else if (params.row.absentColor == 'orange') {
                                            color = 'black'
                                            background = 'orange'
                                        } else if (params.row.absentColor == 'green') {
                                            color = 'white'
                                            background = '#079E46'
                                        } else if (params.row.absentColor == 'blue') {
                                            color = 'black'
                                            background = '#8cbaf9'
                                        }
                                        else {
                                            background = params.row.absentColor
                                        }
                                        return (
                                            <>
                                                {params?.row?.customShiftsArrayDay?.length > 0 && params?.row?.customShiftsArrayDay?.map((shift) => {
                                                    let color = 'white'
                                                    let background = 'black'
                                                    if (shift.absentColor == 'red') {
                                                        color = 'white'
                                                        background = '#E62719'
                                                    } else if (shift.absentColor == 'orange') {
                                                        color = 'black'
                                                        background = 'orange'
                                                    } else if (shift.absentColor == 'green') {
                                                        color = 'white'
                                                        background = '#079E46'
                                                    } else if (shift.absentColor == 'blue') {
                                                        color = 'black'
                                                        background = '#8cbaf9'
                                                    }
                                                    else {
                                                        background = shift.absentColor
                                                    }
                                                    return (
                                                        <div className='shift-arr'>
                                                            <Chip sx={{
                                                                height: 'auto',
                                                                '& .MuiChip-label': {
                                                                    display: 'block',
                                                                    whiteSpace: 'normal',
                                                                },
                                                            }}
                                                                style={{
                                                                    textAlign: 'center',
                                                                    padding: '6px 0px',
                                                                    width: '100%',
                                                                    background: background,
                                                                    color: color,
                                                                    cursor: 'pointer'
                                                                }}
                                                                label={`${shift.absentReason} ${shift.DayFillEmpFirst_name && `(${shift.DayFillEmpEA_Rank} ${shift.DayFIllEmpLast_name})`} (${varFormatTime(shift.custom_time, user?.Time_Format)})`} />
                                                        </div>
                                                    )
                                                })}
                                                {params.row.absentReason &&
                                                    <Chip sx={{
                                                        height: 'auto',
                                                        '& .MuiChip-label': {
                                                            display: 'block',
                                                            whiteSpace: 'normal',
                                                        },
                                                    }}
                                                        style={{ textAlign: 'center', padding: '6px 0px', width: '100%', background: background, color: color, cursor: 'pointer' }}
                                                        label={(params.row.inDayShift ? params.row.absentReason + textEmployee : params.row.absentReason)}
                                                        onClick={(event) => {
                                                            if(permission && permission.includes('Emp_Auth')){
                                                                event.stopPropagation();
                                                                setOverTimeModal(true);
                                                                setIsOnlyNightEmployee(false)
                                                                setSelectEmployee([params.row.Emp_Code]);
                                                            }
                                                        }}
                                                    />
                                                }
                                            </>
                                        )
                                    }
                                    else {
                                        return (
                                            <>
                                                <div
                                                    style={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer' }}
                                                    onClick={(event) => {
                                                        if (permission && permission.includes('Emp_Auth')) {
                                                            event.stopPropagation();
                                                            setIsOnlyNightEmployee(false);
                                                            setOverTimeModal(true);
                                                            setSelectEmployee([params.row.Emp_Code]);
                                                        }
                                                    }}
                                                >
                                                    {permission && permission.includes('Emp_Auth') && (
                                                        <img
                                                            src="/images/three-dot-menu.svg"
                                                            className="m-auto"
                                                            style={{ cursor: 'pointer' }}
                                                            onClick={(event) => {
                                                                event.stopPropagation();
                                                                setIsOnlyNightEmployee(false);
                                                                setOverTimeModal(true);
                                                                setSelectEmployee([params.row.Emp_Code]);
                                                            }}
                                                        />
                                                    )}
                                                </div>
                                            </>
                                        )
                                    }
                                }
                                return (<span>{params.row.inDayShift ? '' : 'X'}</span>);
                            },
                            flex: 1,
                            minWidth: isShortView ? undefined : 120,
                            maxWidth: isShortView ? 60 : undefined,
                        },
                    ]
            );
        }
        else {
            columns = columns.concat(
                (isNightShift) ?
                    [
                        {
                            field: 'inNIGHTShift',
                            headerName: 'Night',
                            filterable: false,
                            renderCell: (params) => {
                                if (pages.includes('V3_SCHEDULE_DN_TOGGLE_SHORTEN_VIEW')) {
                                    return (
                                        <>
                                            {permission && permission.includes('Emp_Auth') &&
                                                <img src="/images/three-dot-menu.svg" className='m-auto' style={{ cursor: 'pointer' }} onClick={() => setOverTimeModal(true)} />
                                            }
                                        </>
                                    )
                                }
                                else {
                                    if (params.row.absentReasonNight || params?.row?.customShiftsArrayNight?.length > 0) {
                                        let textEmployee = '';
                                        if ((params.row.nightStatus == "F" || params.row.nightStatus == "R") && params.row.NightFillEmpFirst_name) {
                                            textEmployee = ' (' + params.row.NightFillEmpEA_Rank + ' ' + params.row.NightFillEmpFirst_name + ' ' + params.row.NightFIllEmpLast_name + ')'
                                        }
                                        let color = 'white'
                                        let background = 'black'
                                        if (params.row.absentColorNight == 'red') {
                                            color = 'white'
                                            background = '#E62719'
                                        } else if (params.row.absentColorNight == 'orange') {
                                            color = 'black'
                                            background = 'orange'
                                        } else if (params.row.absentColorNight == 'green') {
                                            color = 'white'
                                            background = '#079E46'
                                        } else if (params.row.absentColorNight == 'blue') {
                                            color = 'black'
                                            background = '#8cbaf9'
                                        }
                                        else {
                                            background = params.row.absentColorNight
                                        }
                                        return (
                                            <>
                                                {params?.row?.customShiftsArrayNight?.length > 0 && params?.row?.customShiftsArrayNight?.map((shift) => {
                                                    let color = 'white'
                                                    let background = 'black'
                                                    if (shift.absentColor == 'red') {
                                                        color = 'white'
                                                        background = '#E62719'
                                                    } else if (shift.absentColor == 'orange') {
                                                        color = 'black'
                                                        background = 'orange'
                                                    } else if (shift.absentColor == 'green') {
                                                        color = 'white'
                                                        background = '#079E46'
                                                    } else if (shift.absentColor == 'blue') {
                                                        color = 'black'
                                                        background = '#8cbaf9'
                                                    }
                                                    else {
                                                        background = shift.absentColor
                                                    }
                                                    return (
                                                        <div className='shift-arr'>
                                                            <Chip sx={{
                                                                height: 'auto',
                                                                '& .MuiChip-label': {
                                                                    display: 'block',
                                                                    whiteSpace: 'normal',
                                                                },
                                                            }}
                                                                style={{ textAlign: 'center', padding: '6px 0px', width: '100%', background: background, color: color }}
                                                                label={`${shift.absentReason} ${shift.DayFillEmpFirst_name && `(${shift.DayFillEmpEA_Rank} ${shift.DayFillEmpFirst_name} ${shift.DayFillEmpLast_name})`} (${varFormatTime(shift.custom_time, user?.Time_Format)})`} />
                                                        </div>
                                                    )
                                                })}
                                                {params.row.absentReasonNight &&
                                                    <Chip
                                                        sx={{
                                                            height: 'auto',
                                                            '& .MuiChip-label': {
                                                                display: 'block',
                                                                whiteSpace: 'normal',
                                                            },
                                                        }}
                                                        style={{ textAlign: 'center', padding: '6px 0px', width: '100%', background: background, color: color, cursor: 'pointer' }}
                                                        label={params.row.inNIGHTShift ? params.row.absentReasonNight + textEmployee : params.row.absentReasonNight}
                                                    />
                                                }
                                            </>
                                        );
                                    }
                                    else {
                                        return (
                                            <>
                                                {permission && permission.includes('Emp_Auth') &&
                                                    <img src="/images/three-dot-menu.svg" className='m-auto' style={{ cursor: 'pointer' }} onClick={() => setOverTimeModal(true)} />
                                                }
                                            </>
                                        )
                                    }
                                }
                                return (<span>{params.row.inNIGHTShift ? '' : 'X'}</span>);
                            },
                            flex: 1,
                            // minWidth: isShortView ? 160 : 120,
                            // maxWidth: isShortView ? 60 : undefined,
                        },
                    ]
                    :
                    [
                        {
                            field: 'inDayShift',
                            headerName: 'Day',
                            filterable: false,
                            renderCell: (params) => {
                                if (pages.includes('V3_SCHEDULE_DN_TOGGLE_SHORTEN_VIEW')) {
                                    return (
                                        <>
                                            {permission && permission.includes('Emp_Auth') &&
                                                <img src="/images/three-dot-menu.svg" className='m-auto' style={{ cursor: 'pointer' }} onClick={() => setOverTimeModal(true)} />
                                            }
                                        </>
                                    )
                                }
                                else {
                                    if (params.row.absentReason || params?.row?.customShiftsArrayDay?.length > 0) {
                                        let textEmployee = '';
                                        if ((params.row.dayStatus == "F" || params.row.dayStatus == "R") && params.row.DayFillEmpFirst_name) {
                                            textEmployee = ' (' + params.row.DayFillEmpEA_Rank + ' ' + params.row.DayFillEmpFirst_name + ' ' + params.row.DayFIllEmpLast_name + ')'
                                        }
                                        let color = 'white'
                                        let background = 'black'
                                        if (params.row.absentColor == 'red') {
                                            color = 'white'
                                            background = '#E62719'
                                        } else if (params.row.absentColor == 'orange') {
                                            color = 'black'
                                            background = 'orange'
                                        } else if (params.row.absentColor == 'green') {
                                            color = 'white'
                                            background = '#079E46'
                                        } else if (params.row.absentColor == 'blue') {
                                            color = 'black'
                                            background = '#8cbaf9'
                                        }
                                        else {
                                            background = params.row.absentColor
                                        }
                                        return (
                                            <>
                                                {params?.row?.customShiftsArrayDay?.length > 0 && params?.row?.customShiftsArrayDay?.map((shift) => {
                                                    let color = 'white'
                                                    let background = 'black'
                                                    if (shift.absentColor == 'red') {
                                                        color = 'white'
                                                        background = '#E62719'
                                                    } else if (shift.absentColor == 'orange') {
                                                        color = 'black'
                                                        background = 'orange'
                                                    } else if (shift.absentColor == 'green') {
                                                        color = 'white'
                                                        background = '#079E46'
                                                    } else if (shift.absentColor == 'blue') {
                                                        color = 'black'
                                                        background = '#8cbaf9'
                                                    }
                                                    else {
                                                        background = shift.absentColor
                                                    }
                                                    return (
                                                        <div className='shift-arr'>
                                                            <Chip sx={{
                                                                height: 'auto',
                                                                '& .MuiChip-label': {
                                                                    display: 'block',
                                                                    whiteSpace: 'normal',
                                                                },
                                                            }}
                                                                style={{
                                                                    textAlign: 'center',
                                                                    padding: '6px 0px',
                                                                    width: '100%',
                                                                    background: background,
                                                                    color: color,
                                                                    cursor: 'pointer'
                                                                }}
                                                                label={`${shift.absentReason} ${shift.DayFillEmpFirst_name && `(${shift.DayFillEmpEA_Rank} ${shift.DayFillEmpFirst_name} ${shift.DayFIllEmpLast_name})`} (${varFormatTime(shift.custom_time, user?.Time_Format)})`} />
                                                        </div>
                                                    )
                                                })}
                                                {params.row.absentReason &&
                                                    <Chip sx={{
                                                        height: 'auto',
                                                        '& .MuiChip-label': {
                                                            display: 'block',
                                                            whiteSpace: 'normal',
                                                        },
                                                    }}
                                                        style={{ textAlign: 'center', padding: '6px 0px', width: '100%', background: background, color: color, cursor: 'pointer' }}
                                                        label={(params.row.inDayShift ? params.row.absentReason + textEmployee : params.row.absentReason)}
                                                    />
                                                }
                                            </>
                                        )
                                    }
                                    else {
                                        return (
                                            <>
                                                {permission && permission.includes('Emp_Auth') &&
                                                    <img src="/images/three-dot-menu.svg" className='m-auto' style={{ cursor: 'pointer' }} onClick={() => setOverTimeModal(true)} />
                                                }
                                            </>
                                        )
                                    }
                                }
                                return (<span>{params.row.inDayShift ? '' : 'X'}</span>);
                            },
                            flex: 1,
                            // minWidth: isShortView ? 160 : 120,
                            // maxWidth: isShortView ? 60 : undefined,
                        },
                    ]
            );
        }
        if (notAbsentNight != null && totalNight != null) {
            let dayCol = columns.findIndex(item => item.headerName == 'Day');
            if (dayCol > -1) {
                if (allowedVars && Object.keys(allowedVars).includes('V3_REVERSE_STAFF_COUNTS')) {
                    columns[dayCol]['headerName'] = totalDay + '/' + notAbsentDay;
                }
                else if (allowedVars && Object.keys(allowedVars).includes('V3_MINIMUM_STATION_STAFF') && minimumDayStaff !== null) {
                    columns[dayCol]['headerName'] = minimumDayStaff + '/' + notAbsentDay;
                }
                else {
                    columns[dayCol]['headerName'] = notAbsentDay + '/' + totalDay;
                }
            }

            let nightCol = columns.findIndex(item => item.headerName == 'Night');
            if (nightCol > -1) {
                if (allowedVars && Object.keys(allowedVars).includes('V3_REVERSE_STAFF_COUNTS')) {
                    columns[nightCol]['headerName'] = totalNight + '/' + notAbsentNight;
                }
                if (allowedVars && Object.keys(allowedVars).includes('V3_MINIMUM_STATION_STAFF') && minimumNightStaff !== null) {
                    columns[nightCol]['headerName'] = minimumNightStaff + '/' + notAbsentNight;
                }
                else {
                    columns[nightCol]['headerName'] = notAbsentNight + '/' + totalNight;
                }
            }
        }
        return columns;
    };

    const emptyPositionColumns = () => {
        let columns = [
            {
                field: 'emptyPosition',
                headerName: 'Position',
                flex: 1,
                minWidth: !showToggleComponent ? 220 : 300,
                filterable: false,
                renderCell: (params) => {
                    return <div className={`d-flex align-items-center`} style={{ minHeight: '60px' }}>
                        {params.row.positionName}
                    </div>;
                }
            },
            {
                field: 'positionRequirement',
                headerName: 'Minimum Requirement',
                flex: 1,
                minWidth: !showToggleComponent ? 220 : 300,
                filterable: false,
                renderCell: (params) => {
                    return <div className={`d-flex align-items-center`} style={{ minHeight: '60px' }}>
                        {params.row.min}
                    </div>;
                }
            },
        ];
        return columns
    }

    useEffect(() => {
        if (selectedSearchEmp != '') {
            if (routeDate === null) {
                loadData();
            } else {
                loadData(moment(routeDate, 'YYYY-MM-DD').format('DD-MM-YYYY'))
            }
        }
    }, [selectedSearchEmp])

    useEffect(() => {
        if (routeDate === null) {
            loadData();
        } else {
            loadData(moment(routeDate, 'YYYY-MM-DD').format('DD-MM-YYYY'))
        }
    }, [allowedVars && Object.keys(allowedVars).includes('V3_BATTALION_FEATURE')])

    const loadData = (dateInput = '', load = true) => {
        // if (battalion != null) {
        if (load == true) {
            setLoading(true)
        }
        let Query = dateInput != '' ? '?date=' + dateInput : ''
        let Query2 = dateInput != '' ? '&Battalion_Code=' : '?Battalion_Code='
        ApiService.get('/todayShift' + Query + Query2 + selectedSOValue + '&Emp_Code=' + selectedSearchEmp, {}, 'todayShift')
            .then(({ data }) => {
                dispatch(setDashboard(data));
                dispatch(setDashboardSelectedEmp([]))
                setLoading(false)
            }).catch((error) => {
                setLoading(false)
                toast.error("Error")
            })
        // }
    }

    const loadDropDowns = () => {
        const isHidden =
            v3Data?.V3_HIDE_ADJUST_HOURS_REASON === "true";

        const url = isHidden
            ? '/absentCodes'
            : '/absentCodes?condition=all';

        ApiService.get(url, {}, 'absentCodes')
            .then(({ data }) => {
                dispatch(setDashboardAbsentReasonAll(data.data));
            })
            .catch(() => toast.error("Error"));

        ApiService.get('/employeeToSwap', {}, 'employeeToSwap')
            .then(({ data }) => {
                dispatch(setDashboardEmployeeToSwap(data));
            })
            .catch(() => toast.error("Error"));
    };

    const shiftTypes = () => {
        ApiService.get('/shiftTypes', {}, 'shiftTypes').then(({ data }) => {
            dispatch(setDashboardShifts(data.data));
            setAllShifts(data?.data)
        }).catch(() => {
            toast.error("Error")
        })
    }

    const positionDropdown = () => {
        ApiService.get('/getPositionListDDL', {}, 'getPositionListDDL').then(({ data }) => {
            dispatch(setPossitionListDDL(data));
        }).catch(() => {
            toast.error("Error")
        })
    }

    useEffect(() => {
        shiftTypes()
        positionDropdown()
    }, [])

    const loadEmployees = () => {
        setEmpLoading(true)
        ApiService.get('/searchEmployees?search=' + empSearch)
            .then(({ data }) => {
                var tempArr = []
                data.data.map((emp) => {
                    var obj = {
                        label: `${emp.employee_assignment.EA_Rank} ${emp.fullName}`,
                        value: emp.Emp_Code
                    }
                    tempArr.push(obj)
                })
                setEmployees(tempArr)
                setEmpLoading(false)
            })
            .catch((e) => {
                setEmpLoading(false);
            })
    }

    useEffect(() => {
        if (empSearch.length >= 3) {
            loadEmployees()
        }
        else {
            setEmployees([])
        }
    }, [empSearch])

    useEffect(() => {
        if (Shifts.length == 0) {
            loadDropDowns()
        }
        const savedDate = localStorage.getItem('scheduleDate');

        if (routeDate) {
            localStorage.setItem('scheduleDate', routeDate);
            loadData(moment(routeDate, 'YYYY-MM-DD').format('DD-MM-YYYY'))
        } else if (savedDate) {

            setSearchParams({ date: savedDate });
            loadData(moment(savedDate, 'YYYY-MM-DD').format('DD-MM-YYYY'));
        } else {
            if (data == '') {
                loadData()
            } else {
                loadData()
            }
        }

        return () => {
            dispatch(setDashboardSelectedEmp([]))
        }
    }, [])

    let onRowSelectionModelChange = (newSelection) => {
        dispatch(setDashboardSelectedEmp(newSelection))
    }

    const onOpenModal = (newSelection) => {
        dispatch(setDashboardSelectedEmp([newSelection.id]))
        setOverTimeModal(true)
    }

    const memberLog = () => {
        setMode('MemberLog')
    }

    const editEmployee = () => {
        if (SelectedEmp.length > 0) {
            setMode('Edit')
        } else {
            toast.warning("Please select a member first!")
        }
    }

    const notifyTommorowEmp = () => {
        ApiService.post('/sendNotificationToTomorrowEmployee', {}).then(() => {
            toast.success("Notifications sent")
        })
    }

    let getToday = () => {
        const today = dayjs();
        const todayFormatted = today.format('YYYY-MM-DD');
        setSelectedDate(today);
        localStorage.setItem('scheduleDate', todayFormatted);
        loadData(moment().format('DD-MM-YYYY'));
        setSearchParams({ date: moment().format('YYYY-MM-DD') })
    }

    let redirectToRUNCARD = () => {
        if (routeDate) {
            navigate('/firehouse/runcard?date=' + routeDate)
        } else {
            navigate('/firehouse/runcard')
        }
    }

    let redirectToCalendar = () => {
        if (routeDate) {
            navigate('/firehouse/calendar?date=' + routeDate)
        } else {
            navigate('/firehouse/calendar')
        }
    }

    let groupName = Object.keys(pagesName).includes("GROUP_HEADER_TEXT")
        ? pagesName.GROUP_HEADER_TEXT
        : "Group";

    useEffect(() => {
        if (routeDate) {
            loadData(moment(routeDate, 'YYYY-MM-DD').format('DD-MM-YYYY'), false)
        }
    }, [isNightShift])

    useEffect(() => {
        getReqCounts()
        getReqVehicleCounts()
    }, [])

    useEffect(() => {
        if (data) {
            var tempPositionObjNight = {}
            var tempVehicleObjNight = {}
            var emptyOfficersObjNight = {}
            var tempNightData = JSON.parse(JSON.stringify(data));

            tempNightData.stations = tempNightData.stations.map(station => ({
                ...station,
                employees: is_dn_deparment === 'DN_TOGGLE'
                    ? station.employees
                        .filter(emp => emp.inNIGHTShift)
                        .map((emp, i, filteredEmployees) => {
                            if (tempPositionObjNight[emp?.Position_Code] == undefined || tempPositionObjNight[emp?.Position_Code] == null) {
                                if (emp?.customShiftsArrayNight?.length > 0) {
                                    if (emp?.customShiftsArrayNight?.find(a => a.nightStatus != 'F' && a.nightStatus != '')) {
                                        tempPositionObjNight[emp?.Vehicle_Code] = 0;
                                    }
                                }
                                else {
                                    if (emp?.nightStatus != 'F' && emp?.nightStatus != '') {
                                        tempPositionObjNight[emp?.Position_Code] = 0
                                    }
                                    else {
                                        tempPositionObjNight[emp?.Position_Code] = 1
                                    }
                                }
                            }
                            else {
                                if (emp?.customShiftsArrayNight?.length > 0) {
                                    if (emp?.customShiftsArrayNight?.find(a => a.nightStatus == 'F' || a?.nightStatus == '')) {
                                        tempPositionObjNight[emp?.Position_Code] = tempPositionObjNight[emp?.Position_Code] + 1
                                    }
                                }
                                else if (emp?.nightStatus == 'F' || emp?.nightStatus == '') {
                                    tempPositionObjNight[emp?.Position_Code] = tempPositionObjNight[emp?.Position_Code] + 1
                                }
                            }

                            // for vehicle code
                            if (tempVehicleObjNight[emp?.Vehicle_Code] == undefined || tempVehicleObjNight[emp?.Vehicle_Code] == null) {
                                if (emp?.customShiftsArrayNight?.length > 0) {
                                    if (emp?.customShiftsArrayNight?.find(a => a.nightStatus != 'F' && a.nightStatus != '')) {
                                        tempVehicleObjNight[emp?.Vehicle_Code] = 0;
                                        if (emp?.Position_Code.includes('COE') || emp?.Position_Code.includes('COT') || emp?.Position_Code.includes('COR')) {
                                            const engine = `${emp?.PositionName.split(' ')[0]} ${emp?.PositionName.split(' ')[1]}`;
                                            emptyOfficersObjNight[emp?.Position_Code] = engine;
                                        }
                                    } else {
                                        tempVehicleObjNight[emp?.Vehicle_Code] = 1;
                                    }
                                } else {
                                    if (emp?.nightStatus != 'F' && emp?.nightStatus != '') {
                                        tempVehicleObjNight[emp?.Vehicle_Code] = 0;
                                        if (emp?.Position_Code.includes('COE') || emp?.Position_Code.includes('COT') || emp?.Position_Code.includes('COR')) {
                                            const engine = `${emp?.PositionName.split(' ')[0]} ${emp?.PositionName.split(' ')[1]}`;
                                            emptyOfficersObjNight[emp?.Position_Code] = engine;
                                        }
                                    } else {
                                        tempVehicleObjNight[emp?.Vehicle_Code] = 1;
                                    }
                                }
                            }
                            else {
                                if (emp?.customShiftsArrayNight?.length > 0) {
                                    if (emp?.customShiftsArrayNight?.find(a => a.nightStatus == 'F' || a?.nightStatus == '')) {
                                        tempVehicleObjNight[emp?.Vehicle_Code] = tempVehicleObjNight[emp?.Vehicle_Code] + 1;
                                    }
                                } else if (emp?.nightStatus == 'F' || emp?.nightStatus == '') {
                                    tempVehicleObjNight[emp?.Vehicle_Code] = tempVehicleObjNight[emp?.Vehicle_Code] + 1;
                                }
                            }

                            if (i !== 0 && emp.Vehicle_Code !== filteredEmployees[i - 1]?.Vehicle_Code) {
                                return { ...emp, addSeparator: true };
                            }

                            return emp;
                        })
                    : station.employees.filter(emp => emp.inNIGHTShift)
            }));

            tempNightData.dayEmployee = tempNightData.dayEmployee.map(station => ({
                ...station,
                employees: station.employees.filter(employee => employee.inNIGHTShift)
            }));

            setNightData(tempNightData)
            setCurrentPositionCountsNight(tempPositionObjNight)
            setCurrentVehicleCountsNight(tempVehicleObjNight)
            getEmptyCountsNight(tempPositionObjNight, emptyOfficersObjNight)

            var tempVehicleObjDay = {}
            var tempPositionObjDay = {}
            var emptyOfficersObjDay = {}
            var tempDayData = JSON.parse(JSON.stringify(data));

            tempDayData.stations = tempDayData.stations.map(station => ({
                ...station,
                employees: is_dn_deparment === 'DN_TOGGLE'
                    ? station.employees
                        .filter(emp => emp.inDayShift)
                        .map((emp, i, filteredEmployees) => {
                            if (tempPositionObjDay[emp?.Position_Code] == undefined || tempPositionObjDay[emp?.Position_Code] == null) {
                                if (emp?.customShiftsArrayDay?.length > 0) {
                                    if (emp?.customShiftsArrayDay?.find(a => a.dayStatus != 'F' && a.dayStatus != '')) {
                                        tempPositionObjDay[emp?.Position_Code] = 0
                                    }
                                    else {
                                        tempPositionObjDay[emp?.Position_Code] = 1
                                    }
                                }
                                else {
                                    if (emp?.dayStatus != 'F' && emp?.dayStatus != '') {
                                        tempPositionObjDay[emp?.Position_Code] = 0
                                    }
                                    else {
                                        tempPositionObjDay[emp?.Position_Code] = 1
                                    }
                                }
                            }
                            else {
                                if (emp?.customShiftsArrayDay?.length > 0) {
                                    if (emp?.customShiftsArrayDay?.find(a => a.dayStatus == 'F' || a?.dayStatus == '')) {
                                        tempPositionObjDay[emp?.Position_Code] = tempPositionObjDay[emp?.Position_Code] + 1
                                    }
                                }
                                else if (emp?.dayStatus == 'F' || emp?.dayStatus == '') {
                                    tempPositionObjDay[emp?.Position_Code] = tempPositionObjDay[emp?.Position_Code] + 1
                                }
                            }

                            //for vehicle code
                            if (tempVehicleObjDay[emp?.Vehicle_Code] == undefined || tempVehicleObjDay[emp?.Vehicle_Code] == null) {
                                if (emp?.customShiftsArrayDay?.length > 0) {
                                    if (emp?.customShiftsArrayDay?.find(a => a.dayStatus != 'F' && a.dayStatus != '')) {
                                        tempVehicleObjDay[emp?.Vehicle_Code] = 0;
                                        if (emp?.Position_Code.includes('COE') || emp?.Position_Code.includes('COT') || emp?.Position_Code.includes('COR')) {
                                            const engine = `${emp?.PositionName.split(' ')[0]} ${emp?.PositionName.split(' ')[1]}`;
                                            emptyOfficersObjDay[emp?.Position_Code] = engine;
                                        }
                                    } else {
                                        tempVehicleObjDay[emp?.Vehicle_Code] = 1;
                                    }
                                } else {
                                    if (emp?.dayStatus != 'F' && emp?.dayStatus != '') {
                                        tempVehicleObjDay[emp?.Vehicle_Code] = 0;
                                        if (emp?.Position_Code.includes('COE') || emp?.Position_Code.includes('COT') || emp?.Position_Code.includes('COR')) {
                                            const engine = `${emp?.PositionName.split(' ')[0]} ${emp?.PositionName.split(' ')[1]}`;
                                            emptyOfficersObjDay[emp?.Position_Code] = engine;
                                        }
                                    } else {
                                        tempVehicleObjDay[emp?.Vehicle_Code] = 1;
                                    }
                                }
                            }
                            else {
                                if (emp?.customShiftsArrayDay?.length > 0) {
                                    if (emp?.customShiftsArrayDay?.find(a => a.dayStatus == 'F' || a?.dayStatus == '')) {
                                        tempVehicleObjDay[emp?.Vehicle_Code] = tempVehicleObjDay[emp?.Vehicle_Code] + 1;
                                    }
                                } else if (emp?.dayStatus == 'F' || emp?.dayStatus == '') {
                                    tempVehicleObjDay[emp?.Vehicle_Code] = tempVehicleObjDay[emp?.Vehicle_Code] + 1;
                                }
                            }

                            if (i !== 0 && emp.Vehicle_Code !== filteredEmployees[i - 1]?.Vehicle_Code) {
                                return { ...emp, addSeparator: true };
                            }
                            return emp;
                        })
                    : station.employees.filter(emp => emp.inDayShift)
            }));

            tempDayData.dayEmployee = tempDayData.dayEmployee.map(station => ({
                ...station,
                employees: station?.employees?.filter(employee => employee.inDayShift)
            }));

            setDayData(tempDayData)
            setCurrentPositionCounts(tempPositionObjDay)
            setCurrentVehicleCounts(tempVehicleObjDay)
            getEmptyCountsDay(tempPositionObjDay, emptyOfficersObjDay)
            if (!showAllOpenPos) {
                setCanRemoveOpenPos(!canRemoveOpenPos)
            }
        }
    }, [data, mode2, showAllOpenPos, showDropdowns])

    const getEmptyCountsDay = (currObj, emptyObj) => {
        var tempArr = []
        var tempEmptyObj = emptyObj
        Object.keys(currObj).length > 0 && Object.keys(requiredPositionCounts).length > 0 && Object.keys(requiredPositionCounts).map((key, i) => {
            if (currObj[key] == undefined) {
                let obj = {
                    id: i,
                    position: key,
                    min: requiredPositionCounts[key].min,
                    max: requiredPositionCounts[key].max,
                    positionName: requiredPositionCounts[key].position
                }
                tempArr.push(obj)
                if (key.includes('COE') || key.includes('COT') || key.includes('COR')) {
                    const engine = `${obj?.positionName.split(' ')[0]} ${obj?.positionName.split(' ')[1]}`;
                    tempEmptyObj[key] = engine;
                }
            }
        })
        setEmptyCounts(tempArr)
        setEmptyOfficers(tempEmptyObj)
    }

    const getEmptyCountsNight = (currObj, emptyObj) => {
        var tempArr = []
        var tempEmptyObj = emptyObj
        Object.keys(currObj).length > 0 && Object.keys(requiredPositionCounts).length > 0 && Object.keys(requiredPositionCounts).map((key, i) => {
            if (currObj[key] == undefined) {
                let obj = {
                    id: i,
                    position: key,
                    min: requiredPositionCounts[key].min,
                    max: requiredPositionCounts[key].max,
                    positionName: requiredPositionCounts[key].position
                }
                tempArr.push(obj)
                if (key.includes('COE') || key.includes('COT') || key.includes('COR')) {
                    const engine = `${obj?.positionName.split(' ')[0]} ${obj?.positionName.split(' ')[1]}`;
                    tempEmptyObj[key] = engine;
                }
            }
        })
        setEmptyCountsNight(tempArr)
        setEmptyOfficersNight(tempEmptyObj)
    }

    useEffect(() => {
        if (allowedVars && Object.keys(allowedVars).includes('V3_AUTO_HIDE_OPENS_IF_MIN_SATISFIED')) {
            if (currentPositionCounts && requiredPositionCounts) {
                var tempOpenDay = []
                Object.keys(currentPositionCounts).map((item) => {
                    var isOpen = dayData.stations.flatMap(station => station.employees).filter(emp => emp.Position_Code == item && ((emp.absentReason != '' && emp.absentReason != null && emp.dayStatus != 'F') || (emp.customShiftsArrayDay.length > 0 && emp.customShiftsArrayDay.filter(s => s.dayStatus != 'F').length > 0))).map(emp => emp.Emp_Code)
                    if ((parseInt(currentPositionCounts[item]) >= parseInt(requiredPositionCounts[item]?.max)) && isOpen.length > 0) {
                        tempOpenDay = [...tempOpenDay, ...isOpen]
                    }
                })
                const updatedStationsDay = dayData?.stations?.map(station => ({
                    ...station,
                    employees: station.employees.filter(emp => !tempOpenDay.includes(emp.Emp_Code))
                }));
                setDayData({ ...dayData, stations: updatedStationsDay });

                var tempOpenNight = []
                Object.keys(currentPositionCountsNight).map((item) => {
                    var isOpen = nightData.stations.flatMap(station => station.employees).filter(emp => emp.Position_Code == item && ((emp.absentReasonNight != '' && emp.absentReasonNight != null && emp.nightStatus != 'F') || (emp.customShiftsArrayNight.length > 0 && emp.customShiftsArrayNight.filter(s => s.nightStatus != 'F').length > 0))).map(emp => emp.Emp_Code)
                    if ((parseInt(currentPositionCountsNight[item]) >= parseInt(requiredPositionCounts[item]?.max)) && isOpen.length > 0) {
                        tempOpenNight = [...tempOpenNight, ...isOpen]
                    }
                })
                const updatedStationsNight = nightData?.stations?.map(station => ({
                    ...station,
                    employees: station.employees.filter(emp => !tempOpenNight.includes(emp.Emp_Code))
                }));
                setNightData({ ...nightData, stations: updatedStationsNight });
            }
        }
    }, [canRemoveOpenPos])

    const handleRightClick = (event) => {
        // event.preventDefault();
        // console.log('Right click detected!');
    };

    let Battalions = () => {
        ApiService.get('/getBattalions')
            .then((res) => {
                let tempArr = []
                if (res?.data?.data.length > 0) {
                    tempArr = res?.data?.data.map((i) => ({
                        ...i,
                        value: i.SO_Value,
                        label: i.SO_Desc,
                    }));
                    setselectedSOValue(res?.data?.data[0].SO_Value)
                }
                setBattalion(tempArr)
                loadData()
            }).catch(({ error }) => {
                console.log('error', error)
            });
    }

    useEffect(() => {
        if (allowedVars && Object.keys(allowedVars).includes('V3_BATTALION_FEATURE')) {
            Battalions()
        }
    }, [allowedVars && Object.keys(allowedVars).includes('V3_BATTALION_FEATURE')])

    useEffect(() => {
        if (mode2 === 'night') {
            setIsNightShift(true);
        }
        else {
            setIsNightShift(false);
        }
    }, [mode2])

    const getGroupUpcomingDates = () => {
        if (data?.date && pages && pages.includes('V3_NEXT_GROUPS_PILLS')) {
            ApiService.get(`/getGroupUpcomingDates?shift_date=${data?.date}`)
                .then((res) => {
                    setPrevDates(res?.data?.data?.previousDates)
                    setNextDates(res?.data?.data?.upcomingDates)
                })
                .catch(({ error }) => {
                    console.log('error', error)
                })
        }
    }

    useEffect(() => {
        getGroupUpcomingDates()
    }, [data?.date])


    useEffect(() => {
        if (battalion && battalion.length > 0) {
            setShowDropdowns(true)
        }
        else {
            setShowDropdowns(false)
        }
    }, [allowedVars && Object.keys(allowedVars).includes('V3_BATTALION_FEATURE') && battalion])

    useEffect(() => {
        if (data?.date !== undefined) {
            ApiService.get(`/autoPopulateLongevityShifts?date=${data.date}`)
                .then((data) => {
                    if (data?.data?.count > 0) {
                        if (routeDate === null) {
                            loadData('', false);
                        }
                        else {
                            loadData(moment(routeDate, 'YYYY-MM-DD').format('DD-MM-YYYY'), false)
                        }
                    }
                })
                .catch(({ error }) => {
                    toast.error("Error")
                });
        }
    }, [data?.date])

    useEffect(() => {
        if (showDropdowns) {
            setDropdownStyle({
                opacity: 1,
                transform: 'translateY(0)',
                transition: 'opacity 1s ease, transform 0.5s ease',
                pointerEvents: 'auto',
            });
        } else {
            setDropdownStyle({
                opacity: 0,
                transform: 'translateY(-30px)',
                transition: 'opacity 1s ease, transform 0.5s ease',
                pointerEvents: 'none',
            });
        }
    }, [showDropdowns]);

    useEffect(() => {
        if (!showDropdowns) {
            setDropdownStyle2({
                opacity: 1,
                transform: 'translateY(0)',
                transition: 'opacity 1s ease, transform 0.5s ease',
                pointerEvents: 'auto',
            });
        } else {
            setDropdownStyle2({
                opacity: 0,
                transform: 'translateY(-30px)',
                transition: 'opacity 1s ease, transform 0.5s ease',
                pointerEvents: 'none',
            });
        }
    }, [!showDropdowns]);

    useEffect(() => {
        if (selectedSOValue != '') {
            if (routeDate === null) {
                loadData();
            } else {
                loadData(moment(routeDate, 'YYYY-MM-DD').format('DD-MM-YYYY'))
            }
        }
    }, [selectedSOValue])

    useEffect(() => {
        if (routeDate) {
            const routeDateObj = dayjs(routeDate);
            setSelectedDate(routeDateObj);
            // getWeekCalendar(routeDateObj);
            getWeeklySchedule(routeDate);
        }
    }, [routeDate]);

    let changeDate = (date) => {
        const formatted = moment(date).format("MM/DD/YYYY");
        const dayjsDate = dayjs(formatted);
        setSelectedDate(dayjsDate);
        loadData(moment(date).format('DD-MM-YYYY'));
        setSearchParams({ date: moment(date).format('YYYY-MM-DD') });
        setIsNightShift(false);
    }

    const changeDateCalendor = (dateItem) => {
        setSelectedDate(dateItem.fullDate);
        const formattedDate = dateItem.fullDate.format('YYYY-MM-DD');
        localStorage.setItem('scheduleDate', formattedDate);
        loadData(dateItem.fullDate.format('DD-MM-YYYY'));
        setSearchParams({ date: dateItem.fullDate.format('YYYY-MM-DD') });
        setIsNightShift(false);
    }
    const handleStartDate = () => {
        const arr = weekDays?.map(item => Number(item.date));
    }

    useEffect(() => {
        handleStartDate()
    }, [])

    const handlePrint = useReactToPrint({
        contentRef: printRef,
        documentTitle: `Runcard-${moment(routeDate).format('YYYY-MM-DD')}`,
        removeAfterPrint: true,
        onAfterPrint: () => {
            if (clonedDetailRef.current && printRef.current && printRef.current.contains(clonedDetailRef.current)) {
                printRef.current.removeChild(clonedDetailRef.current);
                clonedDetailRef.current = null;
            }
        },
        pageStyle: `@page { 
            size: A4 landscape;
            }

            html, body { margin: 0 !important; padding: 0 !important; }

            body { 
                -webkit-print-color-adjust: exact; 
                print-color-adjust: exact; 
            }

            * { 
            -webkit-print-color-adjust: exact !important; 
            print-color-adjust: exact !important; 
            }

            body * { visibility: hidden !important; }
            #runcardPrintRoot, #runcardPrintRoot * { visibility: visible !important; }

            /* Tighten checkbox column in print */
            #runcardPrintRoot .MuiDataGrid-columnHeader[data-field="__check__"],
            #runcardPrintRoot .MuiDataGrid-cell[data-field="__check__"] {
                display: none !important;
            }

            #runcardPrintRoot { 
                position: static !important; 
                width: 100% !important;
            }

            .noPrint { display: none !important; }

            /* ── SECTION HEAD ── */
            #runcardPrintRoot .sectionHead { color: #fff !important; }
            #runcardPrintRoot .sectionHead * { color: #fff !important; }
            #runcardPrintRoot .sectionHead {
            position: relative !important;
            z-index: 1 !important;
            margin-top: 0 !important;
            padding-top: 4px !important;
            }
            #runcardPrintRoot .sectionHead + * {
            page-break-before: avoid !important;
            break-before: avoid !important;
            margin-top: 0 !important;
            }

            /* ── PAGE BREAKS ── */
            #runcardPrintRoot .station-section {
            page-break-before: always !important;
            break-before: page !important;
            page-break-inside: avoid !important;
            break-inside: avoid !important;
            padding-top: 16px !important;
            margin-top: 16px !important;
            }

            #runcardPrintRoot .station-section:first-of-type {
            page-break-before: avoid !important;
            break-before: avoid !important;
            }

            #runcardPrintRoot .MuiGrid-container {
            page-break-after: avoid !important;
            break-after: avoid !important;
            }

            /* ── COLLAPSE ── */
            #runcardPrintRoot .MuiCollapse-root,
            #runcardPrintRoot .MuiCollapse-wrapper,
            #runcardPrintRoot .MuiCollapse-wrapperInner {
            height: auto !important;
            min-height: 0 !important;
            overflow: visible !important;
            visibility: visible !important;
            }

            /* ── DATAGRID ROOT ── */
            #runcardPrintRoot .MuiDataGrid-root {
            width: 100% !important;
            height: auto !important;
            overflow: visible !important;
            border: none !important;
            }

            #runcardPrintRoot .MuiDataGrid-main {
            height: auto !important;
            overflow: visible !important;
            }

            #runcardPrintRoot .MuiDataGrid-virtualScroller {
            height: auto !important;
            overflow: visible !important;
            margin-top: 0 !important;
            }

            #runcardPrintRoot .MuiDataGrid-virtualScrollerContent {
            height: auto !important;
            overflow: visible !important;
            width: 100% !important;
            min-width: 0 !important;
            position: static !important;
            }

            #runcardPrintRoot .MuiDataGrid-virtualScrollerRenderZone {
            position: static !important;
            transform: none !important;
            width: 100% !important;
            height: auto !important;
            overflow: visible !important;
            }

            /* ── ROWS - KEY FIX ── */
            #runcardPrintRoot .MuiDataGrid-row {
            display: flex !important;
            width: 100% !important;
            min-width: 0 !important;
            height: auto !important;
            max-height: none !important;
            min-height: 0 !important;
            page-break-inside: avoid !important;
            break-inside: avoid !important;
            border-bottom: 1px solid #e0e0e0 !important;
            position: static !important;
            top: unset !important;
            }

            #runcardPrintRoot .MuiDataGrid-row:last-child {
            border-bottom: none !important;
            }

            /* ── COLUMN HEADERS ── */
            #runcardPrintRoot .MuiDataGrid-columnHeaders,
            #runcardPrintRoot .MuiDataGrid-columnHeadersInner {
            width: 100% !important;
            min-width: 0 !important;
            overflow: visible !important;
            position: static !important;
            transform: none !important;
            }

            #runcardPrintRoot .MuiDataGrid-columnHeader {
            flex: 1 1 0 !important;
            min-width: 0 !important;
            max-width: none !important;
            height: auto !important;
            overflow: visible !important;
            }

            #runcardPrintRoot .MuiDataGrid-columnHeaderDraggableContainer,
            #runcardPrintRoot .MuiDataGrid-columnHeaderTitleContainer {
            overflow: visible !important;
            }

            /* ── CELLS ── */
            #runcardPrintRoot .MuiDataGrid-cell {
            flex: 1 1 0 !important;
            min-width: 0 !important;
            max-width: none !important;
            height: auto !important;
            max-height: none !important;
            overflow: visible !important;
            white-space: normal !important;
            word-break: break-word !important;
            align-items: flex-start !important;
            padding: 6px 8px !important;
            border-right: none !important;
            position: static !important;
            }

            /* ── CHIPS ── */
            #runcardPrintRoot .MuiChip-root {
            width: auto !important;
            max-width: 100% !important;
            height: auto !important;
            display: inline-flex !important;
            white-space: normal !important;
            word-break: break-word !important;
            -webkit-print-color-adjust: exact !important;
            print-color-adjust: exact !important;
            }

            #runcardPrintRoot .MuiChip-label {
            white-space: normal !important;
            word-break: break-word !important;
            overflow-wrap: anywhere !important;
            display: block !important;
            }
            /* ── CELL VERTICAL ALIGNMENT FIX ── */
            #runcardPrintRoot .MuiDataGrid-cell {
            flex: 1 1 0 !important;
            min-width: 0 !important;
            max-width: none !important;
            height: auto !important;
            max-height: none !important;
            overflow: visible !important;
            white-space: normal !important;
            word-break: break-word !important;
            padding: 6px 8px !important;
            border-right: none !important;
            position: static !important;
            
            /* ── ADD THESE 3 LINES ── */
            display: flex !important;
            align-items: center !important;
            justify-content: flex-start !important;
            }

            /* ── ROW HEIGHT AUTO ── */
            #runcardPrintRoot .MuiDataGrid-row {
            display: flex !important;
            width: 100% !important;
            min-width: 0 !important;
            height: auto !important;
            max-height: none !important;
            min-height: 0 !important;
            page-break-inside: avoid !important;
            break-inside: avoid !important;
            border-bottom: 1px solid #e0e0e0 !important;
            position: static !important;
            top: unset !important;
            
            /* ── ADD THIS ── */
            align-items: stretch !important;
            }
            /* ── HIDE FOOTER ── */
            #runcardPrintRoot .MuiDataGrid-footerContainer {
            display: none !important;
            }

            /* ── DETAILS SECTION - ALWAYS NEW PAGE ── */
#runcardPrintRoot .management-detail-section {
    page-break-before: always !important;
    break-before: page !important;
    padding-top: 16px !important;
}

/* ── DETAILS TABLE: Reset all JS-injected positioning ── */
#runcardPrintRoot .management-detail-section .MuiDataGrid-root {
    overflow: visible !important;
    height: auto !important;
    width: 100% !important;
}

#runcardPrintRoot .management-detail-section .MuiDataGrid-columnHeaders {
    width: 910px !important;
    min-width: 0 !important;
    overflow: visible !important;
    transform: none !important;
}

#runcardPrintRoot .management-detail-section .MuiDataGrid-columnHeadersInner {
    display: flex !important;
    transform: none !important;
}

#runcardPrintRoot .management-detail-section .MuiDataGrid-columnSeparator {
    display: none !important;
}

#runcardPrintRoot .management-detail-section .MuiDataGrid-columnHeader {
    position: static !important;
    left: unset !important;
    flex: none !important;
    height: auto !important;
    min-height: 36px !important;
    overflow: visible !important;
    display: flex !important;
    align-items: center !important;
    padding: 6px 10px !important;
    box-sizing: border-box !important;
    font-size: 12px !important;
}

#runcardPrintRoot .management-detail-section .MuiDataGrid-columnHeaderDraggableContainer {
    overflow: visible !important;
    display: flex !important;
    width: 100% !important;
}

#runcardPrintRoot .management-detail-section .MuiDataGrid-columnHeaderTitleContainer {
    overflow: visible !important;
    display: flex !important;
    width: 100% !important;
}

#runcardPrintRoot .management-detail-section .MuiDataGrid-columnHeaderTitle {
    font-family: Arial, Helvetica, sans-serif !important;
    font-weight: 600 !important;
    font-size: 12px !important;
    white-space: normal !important;
    word-break: break-word !important;
    overflow: visible !important;
    text-overflow: unset !important;
    line-height: 1.2 !important;
}

#runcardPrintRoot .management-detail-section .MuiDataGrid-menuIcon,
#runcardPrintRoot .management-detail-section .MuiDataGrid-iconButtonContainer {
    display: none !important;
}
#runcardPrintRoot .management-detail-section .MuiDataGrid-row {
    display: flex !important;
    flex-direction: row !important;
    flex-wrap: nowrap !important;
    width: 910px !important;
    height: auto !important;
    min-height: 0 !important;
    position: static !important;
    top: unset !important;
}

#runcardPrintRoot .management-detail-section .MuiDataGrid-cell {
    position: static !important;
    left: unset !important;
    flex: none !important;
    height: auto !important;
    max-height: none !important;
    overflow: visible !important;
    white-space: normal !important;
    word-break: break-word !important;
    display: flex !important;
    align-items: center !important;
    padding: 6px 10px !important;
    box-sizing: border-box !important;
    font-size: 12px !important;
    border-right: none !important;
}

/* ── FIXED COLUMN WIDTHS (matches your on-screen layout) ── */

/* Shift */
#runcardPrintRoot .management-detail-section .MuiDataGrid-columnHeader[data-field="ShiftName"],
#runcardPrintRoot .management-detail-section .MuiDataGrid-cell[data-field="ShiftName"] {
    width: 110px !important;
    min-width: 110px !important;
    max-width: 110px !important;
}

/* Detail Type */
#runcardPrintRoot .management-detail-section .MuiDataGrid-columnHeader[data-field="DetailType"],
#runcardPrintRoot .management-detail-section .MuiDataGrid-cell[data-field="DetailType"] {
    width: 120px !important;
    min-width: 120px !important;
    max-width: 120px !important;
}

/* Assignment */
#runcardPrintRoot .management-detail-section .MuiDataGrid-columnHeader[data-field="AssignmentText"],
#runcardPrintRoot .management-detail-section .MuiDataGrid-cell[data-field="AssignmentText"] {
    width: 120px !important;
    min-width: 120px !important;
    max-width: 120px !important;
}

/* Description - widest */
#runcardPrintRoot .management-detail-section .MuiDataGrid-columnHeader[data-field="DetailText"],
#runcardPrintRoot .management-detail-section .MuiDataGrid-cell[data-field="DetailText"] {
    width: 200px !important;
    min-width: 200px !important;
    max-width: 200px !important;
}

/* Rank */
#runcardPrintRoot .management-detail-section .MuiDataGrid-columnHeader[data-field="PositionName"],
#runcardPrintRoot .management-detail-section .MuiDataGrid-cell[data-field="PositionName"] {
    width: 110px !important;
    min-width: 110px !important;
    max-width: 110px !important;
}

/* EMT */
#runcardPrintRoot .management-detail-section .MuiDataGrid-columnHeader[data-field="EMT"],
#runcardPrintRoot .management-detail-section .MuiDataGrid-cell[data-field="EMT"] {
    width: 90px !important;
    min-width: 90px !important;
    max-width: 90px !important;
}

/* Status */
#runcardPrintRoot .management-detail-section .MuiDataGrid-columnHeader[data-field="StatusText"],
#runcardPrintRoot .management-detail-section .MuiDataGrid-cell[data-field="StatusText"] {
    width: 160px !important;
    min-width: 160px !important;
    max-width: 160px !important;
}

/* ── SCALE TO FIT A4 LANDSCAPE ── */
#runcardPrintRoot .management-detail-section .MuiDataGrid-root {
    transform: scale(0.95) !important;
    transform-origin: top left !important;
}`
    });

    const printFunction = () => {
        if (loading) {
            toast.info("Please wait, still loading data.");
            return;
        }
        if (!printRef.current) {
            toast.error("Nothing to print (print area not ready).");
            return;
        }

        // Clone ManagementDetail into print area before printing
        if (detailRef.current) {
            clonedDetailRef.current = detailRef.current.cloneNode(true);
            printRef.current.appendChild(clonedDetailRef.current);
        }

        handlePrint();
    };

    return (
        <>
            {/* <ManagementHeaderNav /> */}
            {loading && (
                <Box className="w-100 h-100 d-flex justify-content-center align-items-center">
                    <CircularProgress />
                </Box>
            )}
            {!loading && data && mode == '' && (
                <Grid container spacing={2} columns={{ xs: 8, sm: 8, md: 12 }}>
                    <Grid item xs={12} lg={12} md={12}>
                        <Paper elevation={0} className=' shadow '
                            style={{
                                paddingTop: "20px",
                                marginTop: "1rem",
                                backgroundColor: isNightShift ? 'rgba(255, 255, 255, 0.6)' : '#fff',
                                maxWidth: '93vw',
                                overflow: 'auto',
                                msOverflowStyle: 'none',
                                scrollbarWidth: 'none',
                            }}>
                            <div className='schedule-container'>

                                {!isMobile && (
                                    <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap", pl: "10px", fontFamily: 'Karla', marginRight: '30px' }}>
                                        <Grid container alignItems="center" sx={{ px: 1, py: 0 }} >
                                            {/* Schedule Title */}
                                            <Grid item xs={12} sm="auto" md="auto">
                                                <Typography
                                                    variant="h5"
                                                    sx={{
                                                        fontWeight: 600,
                                                        fontSize: { xs: '1.25rem', sm: '1.5rem' },
                                                        fontFamily: 'Karla'
                                                    }}
                                                >
                                                    Schedule
                                                </Typography>
                                            </Grid>

                                            {/* Action Buttons Group */}
                                            <Grid item xs={12} sm="auto" md="auto">
                                                <Box sx={{
                                                    display: "flex",
                                                    gap: 1,
                                                    flexWrap: 'wrap',
                                                    marginLeft: '48px'
                                                }}>
                                                    {permission && permission.includes('Emp_Auth') && (allowedVars?.V3_DEFAULT_MULTI_CHECKBOX_SCHEDULE ? enableMultiSelect : true) &&
                                                        <Button
                                                            onClick={editEmployee}
                                                            disabled={SelectedEmp.length == 0}
                                                            variant="outlined"
                                                            sx={{
                                                                fontSize: { xs: '11px', sm: '12px' },
                                                                padding: { xs: '4px 10px', sm: '5px 12px' },
                                                                textTransform: 'none',
                                                                borderRadius: '8px',
                                                                borderColor: '#E0E0E0',
                                                                color: '#000',
                                                                '&:hover': {
                                                                    borderColor: '#BF1D2D',
                                                                    backgroundColor: 'rgba(191, 29, 45, 0.04)'
                                                                }
                                                            }}
                                                        >
                                                            Edit
                                                        </Button>
                                                    }

                                                    <Button
                                                        onClick={memberLog}
                                                        variant="outlined"
                                                        sx={{
                                                            fontSize: { xs: '11px', sm: '12px' },
                                                            padding: { xs: '4px 10px', sm: '5px 12px' },
                                                            fontFamily: 'Karla',
                                                            textTransform: 'none',
                                                            borderRadius: '8px',
                                                            borderColor: '#E0E0E0',
                                                            color: '#000',
                                                            '&:hover': {
                                                                borderColor: '#BF1D2D',
                                                                backgroundColor: 'rgba(191, 29, 45, 0.04)'
                                                            }
                                                        }}
                                                    >
                                                        View log
                                                    </Button>

                                                    <Button
                                                        onClick={redirectToRUNCARD}
                                                        variant="outlined"
                                                        sx={{
                                                            fontSize: { xs: '11px', sm: '12px' },
                                                            padding: { xs: '4px 10px', sm: '5px 12px' },
                                                            textTransform: 'none',
                                                            fontFamily: 'Karla',
                                                            borderRadius: '8px',
                                                            borderColor: '#E0E0E0',
                                                            color: '#000',
                                                            '&:hover': {
                                                                borderColor: '#BF1D2D',
                                                                backgroundColor: 'rgba(191, 29, 45, 0.04)'
                                                            }
                                                        }}
                                                    >
                                                        Accountability
                                                    </Button>
                                                    <Button
                                                        onClick={() => navigate(routeDate ? `/firehouse/shift-calls?date=${data?.date}` : `/firehouse/shift-calls`)}
                                                        variant="outlined"
                                                        sx={{
                                                            fontSize: { xs: '11px', sm: '12px' },
                                                            padding: { xs: '4px 10px', sm: '5px 12px' },
                                                            fontFamily: 'Karla',
                                                            textTransform: 'none',

                                                            borderRadius: '8px',
                                                            borderColor: '#E0E0E0',
                                                            color: '#000',
                                                            '&:hover': {
                                                                borderColor: '#BF1D2D',
                                                                backgroundColor: 'rgba(191, 29, 45, 0.04)'
                                                            }
                                                        }}
                                                    >
                                                        Shift Calls
                                                    </Button>

                                                    {/* <Button
                                                            variant="outlined"
                                                            onClick={handleClick}
                                                            sx={{
                                                                minWidth: "auto",
                                                                borderRadius: "8px",
                                                                borderColor: "#E0E0E0",
                                                                color: "#000",
                                                                p: { xs: "6px 8px", sm: "6px 10px" },
                                                                "&:hover": {
                                                                    borderColor: "#BF1D2D",
                                                                    backgroundColor: "rgba(191, 29, 45, 0.04)",
                                                                },
                                                            }}
                                                        >
                                                            <ExpandMore />
                                                        </Button> */}
                                                    {/* <Menu
                                                            anchorEl={anchorEl}
                                                            open={open}
                                                            onClose={handleClose}
                                                            PaperProps={{
                                                                sx: {
                                                                    borderRadius: "8px",
                                                                    boxShadow: "0px 4px 10px rgba(0,0,0,0.1)",
                                                                    minWidth: 160,
                                                                },
                                                            }}
                                                        >
                                                            <MenuItem onClick={handleClose}>Option 1</MenuItem>
                                                            <MenuItem onClick={handleClose}>Option 2</MenuItem>
                                                            <MenuItem onClick={handleClose}>Option 3</MenuItem>
                                                            <MenuItem onClick={handleClose}>Different Option 4</MenuItem>
                                                            <Divider />
                                                            <MenuItem
                                                                onClick={handleClose}
                                                                sx={{
                                                                    color: "#BF1D2D",
                                                                    fontWeight: 500,
                                                                }}
                                                            >
                                                                Export to PDF
                                                            </MenuItem>
                                                        </Menu> */}
                                                </Box>
                                            </Grid>
                                            {isIPad ? (<p style={{
                                                display: "flex",
                                                width: "100%",
                                                height: "0.5px",
                                                backgroundColor: "#b1b1b1",
                                                marginTop: '10px',
                                                marginBottom: '0px',
                                                marginRight: '0px',
                                                marginLeft: '0px'
                                            }}></p>) : <span
                                                style={{
                                                    display: "inline-block",
                                                    width: "1.5px",
                                                    height: "25px",
                                                    backgroundColor: "#b1b1b1",
                                                    margin: "0 12px"
                                                }}
                                            ></span>
                                            }

                                            {/* {!isIPad && ( */}
                                            <Grid
                                                item
                                                xs={false}
                                                sm={true}
                                                md={true}
                                                sx={{ display: { xs: 'none', sm: 'block' } }}
                                            />
                                            {/* )} */}


                                            {/* Toggle Buttons */}
                                            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '7px', marginTop: isIPad ? "15px" : '0px' }}>
                                                {showAssignmentsButton && (
                                                    <Button
                                                        onClick={openAssignmentsModal}
                                                        variant="contained"
                                                        sx={{
                                                            fontSize: { xs: '11px', sm: '12px' },
                                                            padding: { xs: '4px 10px', sm: '5px 12px' },
                                                            fontFamily: 'Karla',
                                                            textTransform: 'none',
                                                            borderRadius: '8px',
                                                            boxShadow: 'none',
                                                            backgroundColor: '#BF1D2D',
                                                            color: '#fff',
                                                            '&:hover': {
                                                                backgroundColor: '#a31824',
                                                                boxShadow: 'none',
                                                            }
                                                        }}
                                                    >
                                                        Assignments
                                                    </Button>
                                                )}
                                                {is_dn_deparment == 'DN_TOGGLE' &&
                                                    <ToggleButtonGroup
                                                        value={mode2}
                                                        exclusive
                                                        onChange={handleModeChange}
                                                        aria-label="toggle mode"
                                                        sx={{
                                                            backgroundColor: '#F9FAFB', // light background
                                                            borderRadius: '10px',
                                                            // padding: '1px',
                                                            // marginRight: '10px',
                                                            boxShadow: 'inset 0 0 0 1px #E0E0E0',
                                                            '& .MuiToggleButton-root': {
                                                                px: { xs: 1, sm: 1.5 },
                                                                py: { xs: 0.25, sm: 0.50 },
                                                                textTransform: 'none',
                                                                fontSize: { xs: '12px', sm: '14px' },
                                                                fontWeight: 500,
                                                                fontFamily: 'karla',
                                                                color: '#000',
                                                                border: 'none',
                                                                borderRadius: '8px',
                                                                transition: 'all 0.2s ease',
                                                                '&:hover': {
                                                                    backgroundColor: '#fff',
                                                                    boxShadow: '0 0 0 1px #E0E0E0',
                                                                },
                                                                '&.Mui-selected': {
                                                                    backgroundColor: '#fff',
                                                                    boxShadow: '0 0 0 1px #E0E0E0',
                                                                    color: '#000',
                                                                    '&:hover': {
                                                                        backgroundColor: '#fff',
                                                                    },
                                                                },
                                                                '&:not(:last-of-type)': {
                                                                    marginRight: '0px',
                                                                },
                                                            },
                                                        }}
                                                    >
                                                        <ToggleButton value="day">Day</ToggleButton>
                                                        <ToggleButton value="night">Night</ToggleButton>
                                                        <ToggleButton value="24">24</ToggleButton>
                                                        {allowedVars.V3_WEEKLY_VOLUNTEER_VIEW == "true" && permission.includes('Schedule_Auth') &&
                                                            <ToggleButton component={Link} to="/firehouse/weekly-schedule-view">7 Days</ToggleButton>
                                                        }
                                                    </ToggleButtonGroup>}


                                                {/* Click to Collapse */}
                                                {/* <Grid item xs={12} sm="auto" md="auto">
                                                    <Button
                                                        onClick={toggleAllCollapses}
                                                        variant="outlined"
                                                        startIcon={
                                                            <Box
                                                                component="img"
                                                                src={'/images/collapes.png'}
                                                                alt="Icon"
                                                                sx={{ width: '16px', height: '16px' }}
                                                            />
                                                        }
                                                        sx={{
                                                            fontSize: { xs: '11px', sm: '12px' },
                                                            padding: { xs: '4px 10px', sm: '5px 10px' },
                                                            textTransform: 'none',
                                                            fontFamily:'karla',
                                                            // marginRight: '10px',
                                                            borderRadius: '8px',
                                                            borderColor: '#E0E0E0',
                                                            color: '#000',
                                                            '&:hover': {
                                                                borderColor: '#BF1D2D',
                                                                backgroundColor: 'rgba(191, 29, 45, 0.04)'
                                                            }
                                                        }}
                                                    >
                                                        Click to Collapse
                                                    </Button>
                                                </Grid> */}
                                                <Grid item xs={12} sm="auto" md="auto">
                                                    <Button
                                                        onClick={toggleAllCollapses}
                                                        variant="outlined"
                                                        startIcon={
                                                            <Box
                                                                component="img"
                                                                src={anyExpanded ? '/images/collapse.svg' : '/images/expand.svg'}
                                                                alt="Icon"
                                                                sx={{ width: '16px', height: '16px' }}
                                                            />
                                                        }
                                                        sx={{
                                                            fontSize: { xs: '11px', sm: '12px' },
                                                            padding: { xs: '4px 10px', sm: '5px 10px' },
                                                            textTransform: 'none',
                                                            fontFamily: 'karla',
                                                            borderRadius: '8px',
                                                            borderColor: '#E0E0E0',
                                                            color: '#000',
                                                            '&:hover': {
                                                                borderColor: '#BF1D2D',
                                                                backgroundColor: 'rgba(191, 29, 45, 0.04)'
                                                            }
                                                        }}
                                                    >
                                                        {anyExpanded ? "Click to Collapse" : "Click to Expand"}
                                                    </Button>
                                                </Grid>


                                                {/* Filters */}
                                                <Badge
                                                    badgeContent={activeFilterCount > 0 ? activeFilterCount : 0}
                                                    color="primary"
                                                    overlap="circular"
                                                    invisible={activeFilterCount === 0}
                                                    sx={{
                                                        "& .MuiBadge-badge": {
                                                            fontSize: "10px",
                                                            height: "16px",
                                                            minWidth: "16px",
                                                            top: 4,
                                                            // right: 6,
                                                        },
                                                    }}
                                                >
                                                    <Button
                                                        variant="outlined"
                                                        startIcon={<Box
                                                            component="img"
                                                            src={'/images/filter.png'}
                                                            alt="Icon"
                                                            sx={{ width: '16px', height: '16px' }}
                                                        />}
                                                        onClick={handleFilterClick}
                                                        sx={{
                                                            fontSize: { xs: "11px", sm: "12px" },
                                                            padding: { xs: "6px 12px", sm: "5px 12px" },
                                                            textTransform: "none",
                                                            fontFamily: 'karla',
                                                            borderRadius: "8px",
                                                            borderColor: "#E0E0E0",
                                                            color: "#000",
                                                            "&:hover": {
                                                                borderColor: "#BF1D2D",
                                                                backgroundColor: "rgba(191, 29, 45, 0.04)",
                                                            },
                                                        }}
                                                    >
                                                        Filters
                                                    </Button>
                                                </Badge>
                                            </div>
                                            {/* Dropdown Menu */}
                                            <Menu
                                                anchorEl={filterAnchorEl}
                                                open={filterMenuOpen}
                                                onClose={handleFilterClose}
                                                disableScrollLock={true}
                                                // PaperProps={{
                                                //     sx: {
                                                //         borderRadius: "8px",
                                                //         boxShadow: "0px 4px 10px rgba(0,0,0,0.1)",
                                                //         minWidth: 200,
                                                //         p: 1,
                                                //     },
                                                // }}

                                                PaperProps={{
                                                    sx: {
                                                        borderRadius: "8px",
                                                        boxShadow: "0px 4px 10px rgba(0,0,0,0.1)",
                                                        minWidth: 200,
                                                        marginTop: '10px',
                                                        maxWidth: "calc(100vw - 32px)",
                                                        marginRight: "16px",
                                                        overflow: "visible",
                                                        // Complete padding reset
                                                        "& .MuiList-root": {
                                                            padding: "0 !important",
                                                            paddingTop: "0 !important",
                                                            paddingBottom: "0 !important",
                                                            margin: 0,
                                                        }
                                                    },
                                                }}
                                                MenuListProps={{
                                                    sx: {
                                                        p: 0,
                                                        pt: 0,
                                                        pb: 0,
                                                    }
                                                }}
                                                anchorOrigin={{
                                                    vertical: 'bottom',
                                                    horizontal: 'right',
                                                }}
                                                transformOrigin={{
                                                    vertical: 'top',
                                                    horizontal: 'right',
                                                }}
                                            >

                                                <MenuItem
                                                    sx={{
                                                        display: "flex",
                                                        justifyContent: "space-between",
                                                        alignItems: "center",
                                                    }}
                                                    style={{ paddingBottom: '6px' }}
                                                >
                                                    <Typography fontSize="14px">Show Days</Typography>
                                                    <Switch
                                                        checked={isDaysVisible}
                                                        onChange={(e) => {
                                                            setIsDaysVisible(e.target.checked);
                                                            setShowDay((prev) => !prev);
                                                        }}
                                                        color="primary"
                                                        size="small"
                                                    />
                                                </MenuItem>

                                                {allowedVars && Object.keys(allowedVars).includes('V3_AUTO_HIDE_OPENS_IF_MIN_SATISFIED') &&
                                                    <>
                                                        <Divider style={{ marginTop: '4px', marginBottom: '4px', background: 'rgb(191, 29, 45)' }} />
                                                        <MenuItem
                                                            sx={{
                                                                display: "flex",
                                                                justifyContent: "space-between",
                                                                alignItems: "center",
                                                            }}
                                                            style={{ paddingTop: '6px' }}
                                                        >
                                                            <Typography fontSize="14px">Show Open Positions</Typography>
                                                            <Switch
                                                                checked={isPositionsVisible}
                                                                onChange={(e) => {
                                                                    setIsPositionsVisible(e.target.checked)
                                                                    setShowAllOpenPos(!showAllOpenPos)
                                                                }}
                                                                color="primary"
                                                                size="small"
                                                            />
                                                        </MenuItem>
                                                    </>}

                                                {allowedVars?.V3_DEFAULT_MULTI_CHECKBOX_SCHEDULE && <Divider style={{ marginTop: '4px', marginBottom: '4px', background: 'rgb(191, 29, 45)' }} />}

                                                {allowedVars?.V3_DEFAULT_MULTI_CHECKBOX_SCHEDULE &&
                                                    <MenuItem
                                                        sx={{
                                                            display: "flex",
                                                            justifyContent: "space-between",
                                                            alignItems: "center",
                                                        }}
                                                        style={{ paddingBottom: '6px' }}
                                                    >
                                                        <Typography fontSize="14px">Enable Multiselect</Typography>
                                                        <Switch
                                                            checked={enableMultiSelect}
                                                            onChange={(e) => {
                                                                setEnableMultiSelect(e.target.checked);
                                                            }}
                                                            color="primary"
                                                            size="small"
                                                        />
                                                    </MenuItem>
                                                }

                                            </Menu>
                                        </Grid>
                                        <Grid container spacing={2} alignItems="center" sx={{ mt: 1, px: 1, py: 0 }}>
                                            {/* Go to Today Button */}
                                            <Grid item xs="auto">
                                                <Button
                                                    onClick={getToday}
                                                    variant="contained"
                                                    sx={{
                                                        backgroundColor: 'white',
                                                        color: '#000',
                                                        fontWeight: 500,
                                                        textTransform: 'none',
                                                        borderRadius: '8px',
                                                        marginBottom: '10px',
                                                        borderColor: "#E0E0E0",
                                                        fontFamily: 'karla',
                                                        fontSize: { xs: '12px', sm: '14px' },
                                                        padding: { xs: '4px 12px', sm: '5px 16px' },
                                                        '&:hover': {
                                                            borderColor: '#BF1D2D',
                                                            backgroundColor: 'rgba(191, 29, 45, 0.04)'
                                                        }
                                                    }}
                                                >
                                                    Go to Today
                                                </Button>
                                            </Grid>

                                            <Grid
                                                alignItems="center"
                                                sx={{ mt: 1, ml: 1 }}
                                            >
                                                <Box
                                                    sx={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                        gap: "3px",
                                                    }}
                                                >
                                                    {/* Previous Arrow */}
                                                    <IconButton
                                                        onClick={() => ChangeDateArrow(-1)}

                                                    >
                                                        <ArrowBackIosNewIcon fontSize="small" />
                                                    </IconButton>

                                                    {/* Date Range Display */}
                                                    <Box

                                                    >
                                                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                                                            <ButtonDatePickerNew
                                                                label={formattedRange}

                                                                value={data.date ? moment(data.date).toDate() : new Date()}
                                                                onChange={(e) => changeDate(e)}
                                                            />
                                                        </LocalizationProvider>

                                                    </Box>

                                                    {/* Next Arrow */}
                                                    <IconButton
                                                        onClick={() => ChangeDateArrow(1)}
                                                    // sx={{
                                                    //     border: "1px solid #E0E0E0",
                                                    //     borderRadius: "8px",
                                                    //     p: { xs: "4px", sm: "6px" },
                                                    //     color: "#374151",
                                                    //     "&:hover": { backgroundColor: "#F9FAFB" },
                                                    // }}
                                                    >
                                                        <ArrowForwardIosIcon fontSize="small" />
                                                    </IconButton>
                                                </Box>
                                            </Grid>
                                            {/* Week Days */}

                                            <Grid item xs={12} sm="auto" md="auto" sx={{ pt: '8px !important' }}  >
                                                <Box
                                                    sx={{
                                                        display: "flex",
                                                        gap: 1,
                                                        justifyContent: { xs: "center", sm: "flex-end" },
                                                        flexWrap: "wrap"
                                                    }}
                                                >
                                                    {weekDays.map((item, index) => (

                                                        <Box
                                                            key={index}
                                                            sx={{
                                                                width: { xs: "50px", sm: "60px" },
                                                                textAlign: "center",
                                                                py: 0.4, // ⬅️ reduced height
                                                                px: 1.5,
                                                                borderRadius: "8px",
                                                                bgcolor: item.highlighted ? "#BF1D2D" : "transparent",
                                                                border: item.active
                                                                    ? "1px solid #BF1D2D"
                                                                    : "1px solid #E0E0E0",
                                                                cursor: "pointer",
                                                                position: "relative",
                                                                transition: "all 0.2s ease",
                                                                "&:hover": {
                                                                    borderColor: "#BF1D2D",
                                                                    backgroundColor: item.highlighted
                                                                        ? "#9f1c24"
                                                                        : "rgba(191, 29, 45, 0.04)"
                                                                }
                                                            }}
                                                            onClick={() => changeDateCalendor(item)}
                                                        >
                                                            {/* {item.hasOvertime && (
                                                                    <Box
                                                                        sx={{
                                                                            position: "absolute",
                                                                            bottom: "-3px",
                                                                            right: "43%",
                                                                            width: "8px",
                                                                            height: "8px",
                                                                            borderRadius: "50%",
                                                                            backgroundColor: "#BF1D2D",
                                                                           border: "1px solid #fff",
                                                                            zIndex: 1
                                                                        }}
                                                                    />
                                                                )} */}
                                                            <Box
                                                                sx={{
                                                                    position: "absolute",
                                                                    bottom: "-4px",
                                                                    left: "50%",
                                                                    transform: "translateX(-50%)",
                                                                    display: "flex",
                                                                    gap: "4px",
                                                                    zIndex: 2,
                                                                }}
                                                            >
                                                                {/* 🔴 Red Dot → openPositionCount > 0 */}
                                                                {item.showRedDot && (
                                                                    <Box
                                                                        sx={{
                                                                            width: "7px",
                                                                            height: "7px",
                                                                            borderRadius: "50%",
                                                                            backgroundColor: "#BF1D2D",
                                                                            border: "1px solid #fff",
                                                                        }}
                                                                    />
                                                                )}

                                                                {/* 🟡 Yellow Dot → requestedCount > 0 */}
                                                                {item.showYellowDot && (
                                                                    <Box
                                                                        sx={{
                                                                            width: "7px",
                                                                            height: "7px",
                                                                            borderRadius: "50%",
                                                                            backgroundColor: "#FACC15",
                                                                            border: "1px solid #fff",
                                                                        }}
                                                                    />
                                                                )}
                                                            </Box>

                                                            <Typography
                                                                variant="caption"
                                                                sx={{
                                                                    display: "block",
                                                                    fontSize: "11px",
                                                                    fontWeight: 600,
                                                                    color: item.highlighted ? "#fff" : "#666",
                                                                    mb: 0.5
                                                                }}
                                                            >
                                                                {item.day}
                                                            </Typography>
                                                            {item.group && (
                                                                <Typography
                                                                    style={{ color: item?.color ? item.color.toLowerCase() : "#000" }}
                                                                    sx={{
                                                                        fontSize: "10px",
                                                                        fontWeight: 600,
                                                                        lineHeight: 1,
                                                                        mb: 0.3,
                                                                        // color: CSS.supports("color", item.color?.toLowerCase())
                                                                        //     ? item.color.toLowerCase()
                                                                        //     : "#000",
                                                                    }}
                                                                >
                                                                    {item.group}
                                                                </Typography>
                                                            )}
                                                            <Typography
                                                                variant="h6"
                                                                sx={{
                                                                    fontSize: "16px", // smaller
                                                                    fontWeight: 600,
                                                                    color: item.highlighted ? "#fff" : "#000"
                                                                }}
                                                            >
                                                                {item.date}
                                                            </Typography>

                                                        </Box>
                                                    ))}
                                                </Box>
                                            </Grid>

                                            {/* {!isIPad && ( */}
                                            <Grid
                                                item
                                                xs={false}
                                                sm={true}
                                                md={true}
                                                sx={{ display: { xs: 'none', sm: 'block' } }}
                                            />
                                            {/* )} */}


                                            {/* Group 4 */}

                                            {v3Data?.schedule_daily_roster_pdf &&
                                                <Grid item xs={12} sm="auto" md="auto">
                                                    <ButtonTheme onClick={printFunction} color='primary' disabled={loading}>
                                                        Print
                                                    </ButtonTheme>
                                                </Grid>
                                            }

                                            {(v3Data?.V3_ALLOW_DISPLAY_GARCIA_SCHEDULE && data?.garciaCycle) && (
                                                <Grid item xs={12} sm="auto" md="auto">
                                                    <Chip
                                                        label={`GC: ${moment(data.garciaCycle.start_date).format('MMM D')} - ${moment(data.garciaCycle.end_date).format('MMM D')}`}
                                                        size="small"
                                                        sx={{
                                                            backgroundColor: '#e8f5e9',
                                                            color: '#2e7d32',
                                                            fontWeight: 600,
                                                            fontSize: '12px',
                                                            '& .MuiChip-label': { px: 1.5 }
                                                        }}
                                                    />
                                                </Grid>
                                            )}

                                            <Grid item xs={12} sm="auto" md="auto">
                                                <Typography
                                                    sx={{
                                                        fontWeight: 500,
                                                        fontSize: { xs: '14px', sm: '16px' },
                                                        textAlign: { xs: 'center', sm: 'right' }
                                                    }}
                                                >
                                                    {groupName + ' ' + data.group["DAY"]}
                                                    {/* Group 4 */}
                                                </Typography>
                                            </Grid>
                                        </Grid>
                                    </Box>
                                )}

                                {isMobile && (
                                    <Box sx={{ fontFamily: 'Karla' }}>
                                        {/* Row 1: Title and Date Controls */}
                                        <Box sx={{
                                            display: 'flex',
                                            justifyContent: 'space-between',
                                            alignItems: 'center',
                                            mb: 2,
                                            px: 1
                                        }}>
                                            <Typography
                                                variant="h5"
                                                sx={{
                                                    fontWeight: 600,
                                                    fontSize: '1.25rem'
                                                }}
                                            >
                                                Schedule
                                            </Typography>

                                            <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
                                                {/* Date Display */}
                                                <Box
                                                    sx={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "center",
                                                        gap: 1,
                                                        px: 1.5,
                                                        py: 0.5,
                                                        marginLeft: '5px',
                                                        border: "1px solid #E0E0E0",
                                                        borderRadius: "8px",
                                                        backgroundColor: "#fff",
                                                    }}
                                                >
                                                    {/* Left arrow */}
                                                    <IconButton size="small" onClick={handlePrevDay}>
                                                        <KeyboardArrowLeft sx={{ fontSize: 18, color: "#4B5563" }} />
                                                    </IconButton>

                                                    {/* Date picker (mobile) */}
                                                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                                                        <MobileDatePicker
                                                            label={null}
                                                            format="MM/dd/yyyy"
                                                            value={data.date ? moment(data.date).toDate() : new Date()}
                                                            onChange={(e) => changeDate(e)}
                                                            slotProps={{
                                                                textField: {
                                                                    variant: "standard",
                                                                    InputProps: {
                                                                        disableUnderline: true,
                                                                        sx: {
                                                                            fontSize: { xs: "12px", sm: "14px" },
                                                                            color: "#374151",
                                                                            fontWeight: 500,
                                                                            textAlign: "center",
                                                                            cursor: "pointer",
                                                                            minWidth: "80px",
                                                                        },
                                                                    },
                                                                },
                                                            }}
                                                            sx={{
                                                                "& .MuiInputBase-root": {
                                                                    display: "flex",
                                                                    alignItems: "center",
                                                                    gap: 0.5,
                                                                },
                                                            }}
                                                        />
                                                    </LocalizationProvider>
                                                    <IconButton size="small" onClick={handleNextDay}>
                                                        <KeyboardArrowRight sx={{ fontSize: 18, color: "#4B5563" }} />
                                                    </IconButton>
                                                </Box>
                                                <Button
                                                    onClick={getToday}
                                                    variant="outlined"
                                                    sx={{
                                                        backgroundColor: 'white',
                                                        color: '#000',
                                                        fontWeight: 500,
                                                        textTransform: 'none',
                                                        borderRadius: '8px',
                                                        borderColor: "#E0E0E0",
                                                        fontSize: '12px',
                                                        padding: '4px 12px',
                                                        minWidth: 'auto',
                                                        '&:hover': {
                                                            borderColor: '#BF1D2D',
                                                            backgroundColor: 'rgba(191, 29, 45, 0.04)'
                                                        }
                                                    }}
                                                >
                                                    Today
                                                </Button>
                                            </Box>
                                        </Box>

                                        {/* Row 2: Toggle, Expand, and Options */}
                                        <Box sx={{
                                            display: 'flex',
                                            justifyContent: 'space-between',
                                            alignItems: 'center',
                                            gap: 1,
                                            px: 1
                                        }}>
                                            {/* Day/Night/Both Toggle */}
                                            {is_dn_deparment == 'DN_TOGGLE' &&
                                                <ToggleButtonGroup
                                                    value={mode2}
                                                    exclusive
                                                    onChange={handleModeChange}
                                                    aria-label="toggle mode"
                                                    sx={{
                                                        backgroundColor: '#F9FAFB',
                                                        borderRadius: '8px',
                                                        padding: '2px',
                                                        boxShadow: 'inset 0 0 0 1px #E0E0E0',
                                                        '& .MuiToggleButton-root': {
                                                            px: 2,
                                                            py: 0.5,
                                                            textTransform: 'none',
                                                            fontSize: '12px',
                                                            fontWeight: 500,
                                                            color: '#000',
                                                            border: 'none',
                                                            borderRadius: '6px',
                                                            minWidth: '50px',
                                                            '&.Mui-selected': {
                                                                backgroundColor: '#fff',
                                                                boxShadow: '0 0 0 1px #E0E0E0',
                                                                color: '#000',
                                                            },
                                                        },
                                                    }}
                                                >
                                                    <ToggleButton value="day">Day</ToggleButton>
                                                    <ToggleButton value="night">Night</ToggleButton>
                                                    <ToggleButton value="24">Both</ToggleButton>
                                                </ToggleButtonGroup>}

                                            {/* Expand/Collapse Icon */}
                                            <IconButton
                                                onClick={toggleAllCollapses}
                                                sx={{
                                                    border: "1px solid #E0E0E0",
                                                    borderRadius: "8px",
                                                    p: "6px",
                                                    color: "#374151",
                                                    "&:hover": { backgroundColor: "#F9FAFB" },
                                                }}
                                            >
                                                <Box
                                                    component="img"
                                                    src={'/images/collapes.png'}
                                                    alt="Icon"
                                                    sx={{ width: '16px', height: '16px' }}
                                                />
                                            </IconButton>


                                            {/* Options Button with Menu */}
                                            <Button
                                                variant="outlined"
                                                endIcon={<CgOptions />}
                                                onClick={handleOpenOptions}
                                                sx={{
                                                    borderRadius: "8px",
                                                    borderColor: "#E0E0E0",
                                                    color: "#000",
                                                    fontSize: "12px",
                                                    textTransform: "none",
                                                    px: 2,
                                                    py: 0.5,
                                                    minWidth: 'auto',
                                                    "&:hover": {
                                                        borderColor: "#BF1D2D",
                                                        backgroundColor: "rgba(191, 29, 45, 0.04)",
                                                    },
                                                }}
                                            >
                                                Options
                                            </Button>

                                            {/* Options Menu */}
                                            <Menu
                                                anchorEl={anchorElOptions}
                                                open={Boolean(anchorElOptions)}
                                                onClose={handleCloseOptions}
                                                PaperProps={{
                                                    sx: {
                                                        borderRadius: "8px",
                                                        boxShadow: "0px 4px 10px rgba(0,0,0,0.1)",
                                                        minWidth: 180,
                                                    },
                                                }}
                                            >
                                                {permission && permission.includes('Emp_Auth') && (
                                                    <MenuItem
                                                        onClick={() => {
                                                            handleCloseOptions();
                                                            editEmployee();
                                                        }}
                                                        disabled={SelectedEmp.length == 0 || !moment(data.date).isSameOrAfter(new Date(), "day")}
                                                    >
                                                        Edit
                                                    </MenuItem>
                                                )}
                                                <MenuItem onClick={() => { handleCloseOptions(); memberLog(); }}>
                                                    View Logs
                                                </MenuItem>
                                                <MenuItem onClick={() => { handleCloseOptions(); redirectToRUNCARD(); }}>
                                                    Accountability
                                                </MenuItem>
                                                <MenuItem onClick={() => {
                                                    handleCloseOptions();
                                                    navigate(routeDate ? `/firehouse/shift-calls?date=${data?.date}` : `/firehouse/shift-calls`);
                                                }}>
                                                    Shift Calls
                                                </MenuItem>
                                                {showAssignmentsButton && (
                                                    <MenuItem onClick={() => {
                                                        handleCloseOptions();
                                                        openAssignmentsModal();
                                                    }}>
                                                        Assignments
                                                    </MenuItem>
                                                )}
                                                <Divider />

                                                <MenuItem
                                                    sx={{
                                                        display: "flex",
                                                        justifyContent: "space-between",
                                                        alignItems: "center",
                                                    }}
                                                >
                                                    <Typography fontSize="14px">Show Days</Typography>
                                                    <Switch
                                                        checked={isDaysVisible}
                                                        onChange={(e) => {
                                                            setIsDaysVisible(e.target.checked);
                                                            setShowDay((prev) => !prev); // same logic as desktop
                                                        }}
                                                        color="primary"
                                                        size="small"
                                                    />
                                                </MenuItem>

                                                <Divider />

                                                {allowedVars && Object.keys(allowedVars).includes('V3_AUTO_HIDE_OPENS_IF_MIN_SATISFIED') && <MenuItem
                                                    sx={{
                                                        display: "flex",
                                                        justifyContent: "space-between",
                                                        alignItems: "center",
                                                    }}
                                                >
                                                    <Typography fontSize="14px">Show Open Positions</Typography>
                                                    <Switch
                                                        checked={isPositionsVisible}
                                                        onChange={(e) => {
                                                            setIsPositionsVisible(e.target.checked);
                                                            setShowAllOpenPos(!showAllOpenPos); // same logic as desktop
                                                        }}
                                                        color="primary"
                                                        size="small"
                                                    />
                                                </MenuItem>}
                                                <MenuItem onClick={handleCloseOptions}>
                                                    <ExpandMore sx={{ mr: 1, fontSize: 18 }} /> More Options
                                                </MenuItem>
                                            </Menu>
                                        </Box>
                                    </Box>
                                )}


                                {/*  <Grid container>
                                    <Grid item md={2.7} sm={11} xs={11}>
                                        <Box display="flex" alignItems="center" gap="2px" marginTop="5px">
                                            <Button
                                                style={{ backgroundColor: '#231F20', color: '#fff', fontWeight: '500', marginLeft: "5px" }}
                                                className='rounded-5'
                                                onClick={getToday}>Today
                                            </Button>

                                            <Typography style={{ fontSize: '12px' }}>
                                                {/* {data.group && moment(data.date).format("dddd Do MMMM YYYY")} -  {groupName + ' ' + data.group["DAY"]}}
                                                {data.group && (
                                                    <>
                                                        <div style={{ textAlign: 'center' }}>{moment(data.date).format("MMMM YYYY")} <br />
                                                            <button className='border-0 bg-transparent ' onClick={() => ChangeDateByArrow(-1)}>
                                                                <ArrowLeft />
                                                            </button>
                                                            {moment(data.date).format("ddd Do")} - {groupName + ' ' + data.group["DAY"]}
                                                            <button className='border-0 bg-transparent ' onClick={() => ChangeDateByArrow(1)}>
                                                                <ArrowRight />
                                                            </button>
                                                        </div>
                                                    </>
                                                )}
                                            </Typography>
                                        </Box>
                                    </Grid>
                                    <Grid item md={1.5} sm={3} xs={3} sx={{ marginTop: isMobile ? '20px' : '0px', marginBottom: isMobile ? '-10px' : '' }}>
                                        <div className='mx-0 mt-1'>
                                            <LocalizationProvider dateAdapter={AdapterDateFns}>
                                                <ButtonDatePicker
                                                    label={data.date == null ? null : moment(data.date).format('MM/DD/YYYY')}
                                                    // value={new Date(data.date)}
                                                    value={data.date ? moment(data.date).toDate() : new Date()}
                                                    onChange={(e) => changeDate(e)}
                                                />
                                            </LocalizationProvider>
                                        </div>
                                    </Grid>
                                    <Grid item md={0.7} sm={11} xs={11} sx={{ display: "flex", marginTop: isMobile ? '20px' : '6px', marginLeft: isMobile ? '0px' : '10px' }}>
                                        <Box sx={{ display: "flex", alignItems: 'center', justifyContent: 'end' }}>
                                            {permission && permission.includes('Emp_Auth') &&
                                                <Button className='mx-1 rounded-1' onClick={editEmployee}
                                                    disabled={SelectedEmp.length == 0 || !moment(data.date).isSameOrAfter(new Date(), "day")} sx={buttonStyle}>Edit</Button>
                                            }
                                            {/*  {pages && pages.includes('SCHEDULE_NOTIFICATION_BUTTON') && */}
                                            {/* {permission && permission.includes('Emp_Auth') &&
                                                <Button className='mx-1' onClick={notifyTommorowEmp} sx={buttonStyle}>Notify </Button>
                                            } }
                                        </Box>
                                    </Grid>
																		{showDropdowns == false &&
																			<Grid item md={4.5} sm={11} xs={11} sx={{ ...dropdownStyle2, display: "flex", marginTop: isMobile ? '20px' : '6px', marginLeft: isMobile ? '0px' : '10px' }}>
																				<Box sx={{ display: "flex", alignItems: 'center', justifyContent: 'end' }}>
																							<>
																								<div>
																									<Button className='mx-1' onClick={memberLog} sx={buttonStyle}>View Log</Button>
																									{pages && pages.includes('SCHEDULE_SHOW_HIDE_DAYS') &&
																											<Button className='mx-1' onClick={() => setShowDay(pre => !pre)} sx={buttonStyle}>{showDay ? 'Hide' : 'Show'} Days</Button>
																									}
																									{pages && pages.includes('SCHEDULE_RUNCARD') &&
																											<Button className='mx-1' onClick={redirectToRUNCARD} sx={buttonStyle}>Accountability</Button>
																									}
																									{moment(data.date).isSameOrAfter(moment(), 'day') && permission.includes('Emp_Auth') && pages.includes("V3_NEW_FILL_STRUCTURE") && (
																											<Button
																													className='mx-1'
																													sx={buttonStyle}
																													onClick={() => navigate(routeDate ? `/firehouse/shift-calls?date=${data?.date}` : `/firehouse/shift-calls`)}
																											>
																													{'Shift Calls'}
																											</Button>
																									)}
																								</div>
																								{(
																									(allowedVars && Object.keys(allowedVars).includes('V3_SEARCH_ON_SCHEDULE')) ||
																									((is_dn_deparment === '24_FULL_VIEW' || is_dn_deparment === 'DN_TOGGLE') && battalion && battalion.length > 0)
																								) && (
																									<Tooltip title="Show Battalion & Search dropdown" placement="top">
																										<div onClick={() => setShowDropdowns(true)} style={{ cursor: 'pointer', marginLeft: '10px' }}>
																											<img src='/images/apply-filter.svg' height='20px' width='20px' alt="Show Dropdowns" />
																										</div>
																									</Tooltip>
																								)}
																							</>
																				</Box>
																			</Grid>
																		}
																		
																		{(is_dn_deparment == '24_FULL_VIEW' || is_dn_deparment == 'DN_TOGGLE') && (showDropdowns) && (
																			<Grid item xs={12} sm={12} md={1.7} className='mt-2' sx={{...dropdownStyle}}>
                                          {battalion && battalion.length > 0 &&
																						<div className='mx-2'>
																							<Autocomplete
																								options={battalion}
																								getOptionLabel={(option) => option.label || ''}
																								disableClearable 
																								onChange={(event, newValue) => {
																									if (newValue) {
																										setselectedSOValue(newValue.value);
																									} else {
																										setselectedSOValue('');
																									}
																									setSelectedSearchEmp('');
																								}}
																								value={battalion.find((a) => a.value === selectedSOValue) || null}
																								sx={{
																									"& .MuiInputBase-root": {
																										height: "45px",
																										fontSize: "14px",
																										display: "flex",
																										alignItems: "center"
																									}
																								}}
																								renderInput={(params) => (
																									<TextField
																										{...params}
																										placeholder="Select Battalion"
																									/>
																								)}
																							/>
																						</div>
																					}
                                      </Grid>
																		)}

                                    {(allowedVars && Object.keys(allowedVars).includes('V3_SEARCH_ON_SCHEDULE') && (showDropdowns)) &&
                                        <Grid item xs={12} sm={12} md={1.5} className='mt-2' sx={{...dropdownStyle}}>
                                            <Autocomplete
                                                loading={empLoading}
                                                options={employees}
                                                onChange={(event, newValue) => {
                                                    setSelectedSearchEmp(newValue?.value || '')
                                                    setselectedSOValue('')
                                                    if (newValue == null) {
                                                        setEmployees([])
                                                        setselectedSOValue(battalion[0].SO_Value)
                                                    }
                                                }}
                                                value={employees.find(e => e.value == selectedSearchEmp)}
                                                sx={{
                                                    "& .MuiInputBase-root": {
                                                        height: "45px",
                                                        fontSize: "14px",
                                                        display: "flex",
                                                        alignItems: "center"
                                                    }
                                                }}
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        value={empSearch}
                                                        onChange={(e) => setEmpSearch(e.target.value)}
                                                        placeholder="Search User"
                                                    />
                                                )}
                                            />
                                        </Grid>
                                    }

																		{(
																			(allowedVars && Object.keys(allowedVars).includes('V3_SEARCH_ON_SCHEDULE')) ||
																			((is_dn_deparment === '24_FULL_VIEW' || is_dn_deparment === 'DN_TOGGLE') && battalion && battalion.length > 0)
																		) && (
																			<div>
																				{showDropdowns &&
																					<Grid item md={1} sm={2} xs={2} sx={{...dropdownStyle}}>
																						<div style={{ marginLeft: '20px', cursor: 'pointer', paddingTop: '16px' }}>
																							{showDropdowns && (
																								<Tooltip title="Show View Log & Accountability" placement="top">
																									<div onClick={() => setShowDropdowns(false)}>
																										<img src='/images/remove-filter.svg' height='22px' width='22px' />
																									</div>
																								</Tooltip>
																							)}
																						</div>
																					</Grid>
																				}
																			</div>
																		)}
																		
																		<Grid item md={1.2} sm={2} xs={2}>
                                        <div style={{
                                            cursor: 'pointer',
                                            backgroundColor: 'rgba(245, 245, 245, 0.5)',
                                            borderRadius: '10px', width: '50px', height: '50px',
																						marginLeft:'20px'
                                        }}
                                            onClick={toggleAllCollapses}
                                        >
                                            <Box
                                                component="img"
                                                src={anyExpanded ? '/images/collapse.svg' : '/images/expand.svg'}
                                                alt="Icon"
                                                style={{ width: '14px', height: '14px', marginLeft: isMobile ? '10px' : '19px', marginTop: isMobile ? '30px' : '6px' }}
                                            />
                                            {anyExpanded ?
                                                <p style={{ marginLeft: '6px', paddingTop: '3px', paddingBottom: '8px', fontSize: '10px' }}>Collapse</p>
                                                :
                                                <p style={{ marginLeft: '8px', paddingTop: '3px', paddingBottom: '8px', fontSize: '10px' }}>Expand</p>
                                            }
                                        </div>
                                    </Grid>
																		
                                    <Grid item md={2} sm={2} xs={2}
                                        style={{
                                            position: 'fixed',
                                            top: isScrolled ? 'auto' : '0',
                                            bottom: isScrolled ? '0' : 'auto',
                                            right: '0',
                                            zIndex: 1000,
                                            marginTop: isMobile ? '282px' : '82px',
                                            marginBottom: '30px',
                                            marginRight: "20px",
                                            transition: 'top 3s ease, bottom 0.5s ease',
                                            borderRadius: '60px',
                                            backgroundColor: '#ffffff',
                                            boxShadow: isScrolled ? '0px 0px 10px rgba(0, 0, 0, 0.3)' : 'none'
                                        }}
                                    >
                                        {is_dn_deparment == 'DN_TOGGLE' &&
                                            <ToggleButtonGroup
                                                value={mode2}
                                                exclusive
                                                onChange={handleModeChange}
                                                aria-label="toggle mode"
                                            >
                                                <StyledToggleButton value="day">
                                                    <img src='/images/day.svg' height='20px' width='20px' />
                                                </StyledToggleButton>
                                                <StyledToggleButton value="night">
                                                    <img src='/images/night.svg' height='20px' width='20px' />
                                                </StyledToggleButton>
                                                <StyledToggleButton value="24">
                                                    <img src='/images/fullhour.svg' height='24px' width='24px' />
                                                </StyledToggleButton>
                                            </ToggleButtonGroup>
                                        }
                                    </Grid>
                                </Grid> */}

                                {(is_dn_deparment === 'DN_24_VIEW') &&
                                    <TableContainer sx={{ boxShadow: '10px 10px 20px rgba(0 , 0, 0 , 0.1)' }}>
                                        <Table sx={{
                                            maxWidth: "100%",
                                            mt: 5,
                                            overflow: 'auto',
                                            msOverflowStyle: 'none',
                                            scrollbarWidth: 'none',
                                        }} aria-label="simple table">
                                            <TableHead sx={{ backgroundColor: "#F4F4F4" }} >
                                                <TableRow>
                                                    <TableCell>Shift</TableCell>
                                                    <TableCell align="left">Assigned</TableCell>
                                                    {Object.values(data?.shifts)?.filter((a) => a?.filled)?.length > 0 &&
                                                        <TableCell align="left">Filled</TableCell>
                                                    }
                                                    {data && data.datAbsentKeys && Object.values(data.datAbsentKeys).map((row, i) => (
                                                        <TableCell key={i} align="left">{row}</TableCell>
                                                    ))}
                                                    <TableCell align="left">Officers</TableCell>
                                                    <TableCell align="left">Firefighters</TableCell>
                                                    <TableCell align="left">Total</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {data && data.shifts &&
                                                    Object.values(data.shifts).map((row) => (
                                                        <TableRow key={row.Shift} sx={{ "&:last-child td, &:last-child th": { border: 0 } }}>
                                                            <TableCell component="th" scope="row">
                                                                {row.Shift}
                                                            </TableCell>
                                                            <TableCell align="left">{row.assigned}</TableCell>
                                                            {Object.values(data?.shifts).filter((a) => a?.filled)?.length > 0 &&
                                                                <TableCell align="left">{row.filled}</TableCell>
                                                            }
                                                            {data && data.datAbsentKeys && Object.values(data.datAbsentKeys).map((item) => {
                                                                return <TableCell key={item} align="left">{row.employeeHasOvertimeShifts && Object.entries(row.employeeHasOvertimeShifts)?.find(i => i[0] == item) ? Object.entries(row.employeeHasOvertimeShifts)?.find(i => i[0] == item)[1] : ' '}</TableCell>
                                                            })}
                                                            <TableCell align="left"><Typography color={row.assignedOfficers >= row.minimumOfficers ? 'green' : '#BF1D2D'}>{row.assignedOfficers}</Typography></TableCell>
                                                            <TableCell align="left"><Typography color={((row.allEmployeesCount - row.assignedOfficers) >= (row.minStaff - row.minimumOfficers)) ? 'black' : '#BF1D2D'}>{row.allEmployeesCount - row.assignedOfficers}</Typography></TableCell>
                                                            <TableCell align="left" ><Typography color={row.allEmployeesCount >= row.minStaff ? 'green' : '#BF1D2D'}>{row.allEmployeesCount}</Typography></TableCell>
                                                        </TableRow>
                                                    ))}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                }

                                {is_dn_deparment == '24_FULL_VIEW' &&
                                    <>
                                        {data?.stations?.length > 0 &&
                                            <TableContainer sx={{ boxShadow: '10px 10px 20px rgba(0 , 0, 0 , 0.1)' }}>
                                                <Table sx={{
                                                    maxWidth: "100%", mt: 1, overflow: 'auto',
                                                    msOverflowStyle: 'none',
                                                    scrollbarWidth: 'none',
                                                }} aria-label="simple table">
                                                    <TableHead sx={{ backgroundColor: "#F4F4F4" }} >
                                                        <TableRow>
                                                            <TableCell>Shift</TableCell>
                                                            <TableCell align="left">Assigned</TableCell>
                                                            {Object.values(data?.shifts)?.filter((a) => a?.filled)?.length > 0 &&
                                                                <TableCell align="left">Filled</TableCell>
                                                            }
                                                            {data && data.datAbsentKeys && Object.values(data.datAbsentKeys).map((row, i) => (
                                                                <TableCell key={i} align="left">{row}</TableCell>
                                                            ))}
                                                            <TableCell align="left">Officers</TableCell>
                                                            <TableCell align="left">Firefighters</TableCell>
                                                            <TableCell align="left">Total</TableCell>
                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                        {data && data.shifts &&
                                                            Object.values(data.shifts).map((row) => (
                                                                <TableRow key={row.Shift} sx={{ "&:last-child td, &:last-child th": { border: 0 } }}>
                                                                    <TableCell component="th" scope="row">
                                                                        {row.Shift}
                                                                    </TableCell>
                                                                    <TableCell align="left">{row.assigned}</TableCell>
                                                                    {Object.values(data?.shifts).filter((a) => a?.filled)?.length > 0 &&
                                                                        <TableCell align="left">{row.filled}</TableCell>
                                                                    }
                                                                    {data && data.datAbsentKeys && Object.values(data.datAbsentKeys).map((item) => {
                                                                        return <TableCell key={item} align="left">{row.employeeHasOvertimeShifts && Object.entries(row.employeeHasOvertimeShifts)?.find(i => i[0] == item) ? Object.entries(row.employeeHasOvertimeShifts)?.find(i => i[0] == item)[1] : ' '}</TableCell>
                                                                    })}
                                                                    <TableCell align="left"><Typography color={row.assignedOfficers >= row.minimumOfficers ? 'green' : '#BF1D2D'}>{row.assignedOfficers}</Typography></TableCell>
                                                                    <TableCell align="left"><Typography color={((row.allEmployeesCount - row.assignedOfficers) >= (row.minStaff - row.minimumOfficers)) ? 'black' : '#BF1D2D'}>{row.allEmployeesCount - row.assignedOfficers}</Typography></TableCell>
                                                                    <TableCell align="left" ><Typography color={row.allEmployeesCount >= row.minStaff ? 'green' : '#BF1D2D'}>{row.allEmployeesCount}</Typography></TableCell>
                                                                </TableRow>
                                                            ))}
                                                    </TableBody>
                                                </Table>
                                            </TableContainer>
                                        }
                                        {data?.stations?.length === 0 &&
                                            <div className='my-5'>
                                                <EmptyState text='There is no schedule available for this date' />
                                            </div>
                                        }
                                    </>
                                }

                                {/*<div style={{ display: 'flex' }}>
                                    {is_dn_deparment == 'DN_TOGGLE' && pages && pages.includes('V3_NEXT_GROUPS_PILLS') &&
                                        <>
                                            <Typography variant="h6" component="h6" sx={{ marginTop: '22px', marginLeft: '10px', marginRight: '10px', fontWeight: '550' }}>
                                                {groupName + ' ' + data.group["DAY"]}
                                            </Typography>
                                            <div>
                                                {prevdates.map((dates) => (
                                                    <Button
                                                        variant="contained"
                                                        disableElevation
                                                        onClick={() => changeDate(dates)}
                                                        sx={{
                                                            borderRadius: "40px",
                                                            margin: "0px 5px",
                                                            marginTop: '20px',
                                                            backgroundColor: "rgba(191, 29, 45, 0.8)",
                                                            color: '#ffffff',
                                                            height: "36px !important",
                                                            gap: "10px",
                                                            padding: "0px 16px",
                                                            "&:hover": {
                                                                backgroundColor: "#9f1c24",
                                                                color: '#ffffff',
                                                                transition: "all 0.3s ease",
                                                            },
                                                        }}
                                                    >
                                                        <img
                                                            src='/images/group.svg'
                                                            height="16px" width="16px"
                                                        />
                                                        <p style={{ fontSize: "12px", marginTop: "16px" }}>{moment(dates).format('MM/DD/YYYY')}</p>
                                                    </Button>
                                                ))}
                                                {nextDates.map((dates) => (
                                                    <Button
                                                        variant="contained"
                                                        disableElevation
                                                        onClick={() => changeDate(dates)}
                                                        sx={{
                                                            borderRadius: "40px",
                                                            margin: "0px 5px",
                                                            marginTop: '20px',
                                                            backgroundColor: "rgba(191, 29, 45, 0.8)",
                                                            color: '#ffffff',
                                                            height: "36px !important",
                                                            gap: "10px",
                                                            padding: "0px 16px",
                                                            "&:hover": {
                                                                backgroundColor: "#9f1c24",
                                                                color: '#ffffff',
                                                                transition: "all 0.3s ease",
                                                            },
                                                        }}
                                                    >
                                                        <img
                                                            src='/images/group.svg'
                                                            height="16px" width="16px"
                                                        />
                                                        <p style={{ fontSize: "12px", marginTop: "16px" }}>{moment(dates).format('MM/DD/YYYY')}</p>
                                                    </Button>
                                                ))}
                                            </div>
                                        </>
                                    }
                                    {allowedVars && Object.keys(allowedVars).includes('V3_AUTO_HIDE_OPENS_IF_MIN_SATISFIED') &&
                                        <Button className='mt-3 ms-2' sx={buttonStyle}
                                            onClick={() => setShowAllOpenPos(!showAllOpenPos)} >
                                            {showAllOpenPos ? 'Hide Min Open Position' : 'Show All Open Positions'}
                                        </Button>
                                    }

                                </div> */}

                                {is_dn_deparment == 'DN_TOGGLE' && allowedVars && !Object.keys(allowedVars).includes('V3_SCHEDULE_HIDE') &&
                                    <>
                                        {data?.stations?.length === 0 &&
                                            <div className='my-5'>
                                                <EmptyState text='There is no schedule available for this date' />
                                            </div>
                                        }
                                    </>
                                }
                                <div id="runcardPrintRoot" ref={printRef}>
                                    {is_dn_deparment == '24_FULL_VIEW' ? (
                                        <FullViewComponent
                                            showDay={showDay}
                                            onRowSelectionModelChange={onRowSelectionModelChange}
                                            SelectedEmp={SelectedEmp}
                                            expandAll={expandAll}
                                            handleExpandChange={handleExpandChange}
                                            permission={permission}
                                            onOpenModal={onOpenModal}
                                            anyExpanded={anyExpanded}
                                            handleRightClick={handleRightClick}
                                            dayData={dayData}
                                            reformatColumns={reformatColumns}
                                            is_dn_deparment={is_dn_deparment}
                                            enableMultiSelect={enableMultiSelect}
                                        />
                                    ) : is_dn_deparment == 'DN_24_VIEW' ? (
                                        <HorizontalComponent
                                            showDay={showDay}
                                            onRowSelectionModelChange={onRowSelectionModelChange}
                                            SelectedEmp={SelectedEmp}
                                            expandAll={expandAll}
                                            handleExpandChange={handleExpandChange}
                                            permission={permission}
                                            onOpenModal={onOpenModal}
                                            anyExpanded={anyExpanded}
                                            handleRightClick={handleRightClick}
                                            dayData={dayData}
                                            nightData={nightData}
                                            reformatColumns={reformatColumns}
                                            setIsNightShift={setIsNightShift}
                                            is_dn_deparment={is_dn_deparment}
                                            enableMultiSelect={enableMultiSelect}
                                            isPrint={true}
                                        />
                                    ) : (
                                        mode2 === '24' ? (
                                            <HorizontalComponent
                                                showDay={showDay}
                                                onRowSelectionModelChange={onRowSelectionModelChange}
                                                SelectedEmp={SelectedEmp}
                                                expandAll={expandAll}
                                                handleExpandChange={handleExpandChange}
                                                permission={permission}
                                                onOpenModal={onOpenModal}
                                                anyExpanded={anyExpanded}
                                                handleRightClick={handleRightClick}
                                                dayData={dayData}
                                                nightData={nightData}
                                                reformatColumns={reformatColumns}
                                                setIsNightShift={setIsNightShift}
                                                is_dn_deparment={is_dn_deparment}
                                                mode2={mode2}
                                                enableMultiSelect={enableMultiSelect}
                                            />
                                        ) : (
                                            <ToggleComponent
                                                showDay={showDay}
                                                newData={isNightShift ? nightData : dayData}
                                                reformatColumns={reformatColumns}
                                                onRowSelectionModelChange={onRowSelectionModelChange}
                                                SelectedEmp={SelectedEmp}
                                                expandAll={expandAll}
                                                handleExpandChange={handleExpandChange}
                                                permission={permission}
                                                onOpenModal={onOpenModal}
                                                anyExpanded={anyExpanded}
                                                data={data}
                                                handleRightClick={handleRightClick}
                                                emptyCounts={isNightShift ? emptyCountsNight : emptyCounts}
                                                emptyPositionColumns={emptyPositionColumns}
                                                date={routeDate}
                                                loadData={loadData}
                                                is_dn_deparment={is_dn_deparment}
                                                accordionDate={data.date}
                                                pages={pages}
                                                isNightShift={isNightShift}
                                                mode2={mode2}
                                                enableMultiSelect={enableMultiSelect}
                                                isPrint={true}
                                            />
                                        )
                                    )}
                                </div>
                                {
                                    (allowedVars && Object.keys(allowedVars).includes('V3_ALTERNATE_SCHEDULE'))
                                        ?
                                        <RotationTable
                                            positions={PossitionListDDL}
                                            shifts={Shifts} date={date}
                                            open={expandAll}
                                            onExpandChange={handleExpandChange}
                                        />
                                        :
                                        ""
                                }


                                {pages && pages.includes('V3_Volunteer_Signup') &&
                                    <VolunteerSignup
                                        onExpandChange={handleExpandChange}
                                        open={expandAll}
                                        mode2={mode2}
                                        isNightShift={isNightShift}
                                        date={routeDate}
                                        allowedVars={allowedVars}
                                        shift={allShifts}
                                    />
                                }
                                <br />

                                {/*Schedule Notes*/}
                                {pages && pages.includes('SCHEDULE_DISPLAY_NOTES') &&
                                    <AddNote pages={pages} permission={permission} />
                                }
                                {/*Add seperator if notes active*/}
                                {pages && pages.includes('SCHEDULE_DISPLAY_NOTES') &&
                                    <hr />
                                }

                                <div ref={detailRef} className="management-detail-section">
                                    <ManagementDetail />
                                    {allowedVars && Object.keys(allowedVars).includes('V3_SHOW_TRAINING_ON_SCHEDULE') &&
                                    <OffDutyTraining />}
                                </div>
                                {allowedVars && Object.keys(allowedVars).includes('SCHEDULE_DISPLAY_OFFICER_ASSIGN_DUTY_CREW') &&
                                    <DutyCrew
                                        isReload={isReload}
                                        setIsReload={setIsReload}
                                    />
                                }
                                {pages && pages.includes('SCHEDULE_DISPLAY_OUT_OF_TOWN') &&
                                    <OutOfTown
                                        onExpandChange={handleExpandChange}
                                        open={expandAll}
                                    />
                                }
                                {pages && pages.includes('AVAILABILITY') &&
                                    <Available
                                        onExpandChange={handleExpandChange}
                                        open={expandAll}
                                        isReload={isReload}
                                        setIsReload={setIsReload}
                                    />
                                }
                                <br />
                            </div>
                        </Paper>
                    </Grid>
                </Grid>
            )}

            {!loading && mode == 'Edit' && <AddOverTime loadData={loadData} EmpIds={SelectedEmp} backFunction={() => { dispatch(setDashboardSelectedEmp([])); setMode(''); loadData(moment(data.date).format('DD-MM-YYYY')); getWeeklySchedule(selectedDate); }} isNightShift={isNightShift} allowedVars={allowedVars}></AddOverTime>}
            {!loading && mode == 'MemberLog' && <DashboardMemberLog backFunction={() => { dispatch(setDashboardSelectedEmp([])); setMode(''); }}></DashboardMemberLog>}

            <Modal show={overTimeModal} size="lg">
                <Modal.Body className='p-0'>
                    <AddOverTime loadData={loadData}
                        // EmpIds={(mode2 == '24' && is_dn_deparment == 'DN_TOGGLE') || (is_dn_deparment == 'DN_24_VIEW') ? selectEmployee || SelectedEmp : SelectedEmp}
                        EmpIds={SelectedEmp}
                        EmpIds2={selectEmployee}
                        backFunction={() => {
                            dispatch(setDashboardSelectedEmp([]));
                            setSelectEmployee([])
                            setMode('');
                            // loadData(moment(data.date).format('DD-MM-YYYY'), false);
                            setOverTimeModal(false)
                            getWeeklySchedule(selectedDate)
                        }}

                        isNightShift={isNightShift}
                        setOverTimeModal={setOverTimeModal}
                        allowedVars={allowedVars}
                        is_dn_deparment={is_dn_deparment}
                        isOnlyNightEmployee={isOnlyNightEmployee}
                    ></AddOverTime>
                </Modal.Body>
            </Modal>

            <Modal show={assignModal} size='lg'>
                <Modal.Body className='p-0'>
                    <QuickAssign
                        loadData={loadData}
                        EmpIds={selectEmployee}
                        backFunction={() => {
                            // dispatch(setDashboardSelectedEmp([]));
                            setSelectEmployee([])
                            loadData(moment(data.date).format('DD-MM-YYYY'), false);
                            setAssignModal(false)
                            setShift('')
                            getWeeklySchedule(selectedDate)

                        }}
                        date={data.date}
                        setAssignModal={setAssignModal}
                        isNightShift={isNightShift}
                        mode={mode2}
                        shift={shift}
                        setShift={setShift}
                    />
                </Modal.Body>
            </Modal>

            <Modal show={assigndataModal} size='md'>
                <Modal.Body className='p-0'>
                    <AssignModal
                        loadData={loadData}
                        EmpIds={selectEmployee}
                        backFunction={() => {
                            // dispatch(setDashboardSelectedEmp([]));
                            setSelectEmployee([])
                            loadData(moment(data.date).format('DD-MM-YYYY'), false);
                            setAssignDataModal(false)
                            setShift('')
                        }}
                        date={data.date}
                        setAssignDataModal={setAssignDataModal}
                        isNightShift={isNightShift}
                        mode={mode2}
                        shift={shift}
                        setShift={setShift}
                    />
                </Modal.Body>
            </Modal>

            <Modal show={revertStation} onHide={() => setRevertStation(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Revert Station Detail</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <RevertStation
                        loadData={loadData}
                        revertData={revertData}
                        backFunction={() => {
                            setRevertData([])
                            loadData(moment(data.date).format('DD-MM-YYYY'), false);
                            setRevertStation(false)
                            setShift('')
                        }}
                        date={data.date}
                        shift={shift}
                        setRevertStation={setRevertStation}
                    />
                </Modal.Body>
            </Modal>

            <Modal show={assignmentsModal} onHide={() => setAssignmentsModal(false)} size="xl" dialogClassName="assignments-modal">
                <Modal.Body className="p-0" style={{ backgroundColor: '#F9FAFB', borderRadius: '6px' }}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', px: 3, pt: 3, pb: 1 }}>
                        <Typography sx={{ fontSize: '21px', fontWeight: '700', fontFamily: 'Karla' }}>
                            Assignments
                        </Typography>
                        <img
                            src="/images/close-icon.svg"
                            style={{ cursor: 'pointer' }}
                            onClick={() => setAssignmentsModal(false)}
                            alt="Close"
                        />
                    </Box>

                    <Tabs
                        value={assignmentsTab}
                        onChange={(e, val) => setAssignmentsTab(val)}
                        variant="scrollable"
                        scrollButtons="auto"
                        sx={{
                            px: 3,
                            minHeight: '42px',
                            '& .MuiTab-root': {
                                textTransform: 'none',
                                fontWeight: 600,
                                fontFamily: 'Karla',
                                fontSize: '14px',
                                minHeight: '42px',
                                color: '#6B7280',
                            },
                            '& .Mui-selected': { color: '#BF1D2D !important' },
                            '& .MuiTabs-indicator': { backgroundColor: '#BF1D2D', height: '3px', borderRadius: '3px 3px 0 0' }
                        }}
                    >
                        {canViewAssignmentRequests && <Tab value="requests" label="Assignment Requests" />}
                        {canViewCancelledAssignments && <Tab value="cancelled" label="Cancelled Assignments" />}
                        {canViewVolunteerSignup && <Tab value="volunteerSignup" label={volunteerSignupLabel} />}
                    </Tabs>

                    <Box sx={{ px: 3, pb: 3, pt: 2, backgroundColor: '#F9FAFB' }}>
                        <Box
                            sx={{
                                backgroundColor: '#fff',
                                border: '1px solid #EAECF0',
                                borderRadius: '12px',
                                p: { xs: 2, sm: 2.5 },
                                maxHeight: '65vh',
                                overflowY: 'auto',
                            }}
                        >
                            {assignmentsTab === 'requests' && canViewAssignmentRequests && <AssignmentRequests embedded />}
                            {assignmentsTab === 'cancelled' && canViewCancelledAssignments && <CancelledAssignments embedded />}
                            {assignmentsTab === 'volunteerSignup' && canViewVolunteerSignup && <VolunteerSignupNew embedded />}
                        </Box>
                    </Box>
                </Modal.Body>
            </Modal>

            {showAlert &&
                <SweetAlert
                    warning
                    showCancel
                    confirmBtnText="Confirm"
                    confirmBtnBsStyle="danger"
                    title="Employee Re-assignment"
                    onConfirm={changeEmpPossion}
                    onCancel={() => {
                        dispatch(setDashboardSelectedEmp([]));
                        setSelectEmployee([])
                        // loadData(moment(data.date).format('DD-MM-YYYY'), false);
                        setShowAlert(false)
                    }}
                    focusCancelBtn
                >
                    Are you sure you want to re-assign this position?
                </SweetAlert>
            }

            {eligibleAlert &&
                <SweetAlert
                    warning
                    showCancel
                    confirmBtnText="Confirm"
                    confirmBtnBsStyle="danger"
                    title="Employee Eligibility"
                    onConfirm={empPositionEligible}
                    onCancel={() => {
                        dispatch(setDashboardSelectedEmp([]));
                        setSelectEmployee([])
                        // loadData(moment(data.date).format('DD-MM-YYYY'), false);
                        setEligibleAlert(false)
                    }}
                    focusCancelBtn
                >
                    {positionData?.emp?.fullName} is not eligible for {positionData?.e?.label} position. Are you sure you want to continue this assignment?
                </SweetAlert>
            }
        </>
    );
}